export const thingsToDoArr = [];

export const WebinarsData = [
  {
    imgVideo: "Resources/Webinars/1.jpg",
    vidId: "KC44gauVfRs",
    desc: "Israel for Every Generation",
    category: "jewish",
  },
  // {
  //   imgVideo: "Resources/Webinars/2.jpg",
  //   vidId: "ZsOYCxgBSvw",
  //   desc: "Museum Madness - Monument Monday",
  //   category: "jewish",
  // },
  // {
  //   imgVideo: "Resources/Webinars/3.jpg",
  //   vidId: "VQVkItpZ9eM",
  //   desc: "Museum Madness - Tapestry Tuesday",
  //   category: "jewish",
  // },
  // {
  //   imgVideo: "Resources/Webinars/4.jpg",
  //   vidId: "iCWCTz5aMM0",
  //   desc: "Museum Madness - Wondrous Wednesday",
  //   category: "jewish",
  // },
  // {
  //   imgVideo: "Resources/Webinars/7.jpg",
  //   vidId: "0dwfMjRjrMY",
  //   desc: "Museum Madness - Thoughtful Thursday",
  //   category: "jewish",
  // },
  {
    imgVideo: "Resources/Webinars/8.jpg",
    vidId: "08Kw2Yy1MTw",
    desc: "A Sip of Israel Wine Webinar",
    category: "jewish",
  },
  {
    imgVideo: "Resources/Webinars/5.jpg",
    vidId: "VzJ1DwpLckw",
    desc: "Accessible Israel Webinar",
    category: "jewish",
  },
  {
    imgVideo: "Resources/Webinars/10.jpg",
    vidId: "yNMRHfE7KY8",
    desc: "Sustainability in Israel on the Birthday of the Trees",
    category: "jewish",
  },
  {
    imgVideo: "Resources/Webinars/9.jpg",
    vidId: "yuLPwY0ue5Q",
    desc: "Home of the Holidays",
    category: "jewish",
  },

  {
    imgVideo: "Resources/Webinars/1.jpg",
    vidId: "M4CPdjJUWKU",
    desc: "Christians in the Holy Land",
    category: "christian",
  },
  {
    imgVideo: "Resources/Webinars/2.jpg",
    vidId: "5Qh7tW-yi9o",
    desc: "Easter in Israel",
    category: "christian",
  },
  {
    imgVideo: "Resources/Webinars/3.jpg",
    vidId: "AqfwYcxigMs",
    desc: "City of David",
    category: "christian",
  },
  {
    imgVideo: "Resources/Webinars/9.jpg",
    vidId: "yuLPwY0ue5Q",
    desc: "Home of the Holidays",
    category: "christian",
  },
  {
    imgVideo: "Resources/Webinars/5.jpg",
    vidId: "iG1XXEOx_OI",
    desc: "Early Christianity in Caesarea Maritima",
    category: "christian",
  },

  {
    imgVideo: "Resources/Webinars/1.jpg",
    vidId: "KC44gauVfRs",
    desc: "Israel for Every Generation",
    category: "general",
  },
  // {
  //   imgVideo: "Resources/Webinars/2.jpg",
  //   vidId: "ZsOYCxgBSvw",
  //   desc: "Museum Madness - Monument Monday",
  //   category: "general",
  // },
  // {
  //   imgVideo: "Resources/Webinars/3.jpg",
  //   vidId: "VQVkItpZ9eM",
  //   desc: "Museum Madness - Tapestry Tuesday",
  //   category: "general",
  // },
  // {
  //   imgVideo: "Resources/Webinars/4.jpg",
  //   vidId: "iCWCTz5aMM0",
  //   desc: "Museum Madness - Wondrous Wednesday",
  //   category: "general",
  // },
  // {
  //   imgVideo: "Resources/Webinars/7.jpg",
  //   vidId: "0dwfMjRjrMY",
  //   desc: "Museum Madness - Thoughtful Thursday",
  //   category: "general",
  // },
  {
    imgVideo: "Resources/Webinars/8.jpg",
    vidId: "08Kw2Yy1MTw",
    desc: "A Sip of Israel Wine Webinar",
    category: "general",
  },
  {
    imgVideo: "Resources/Webinars/5.jpg",
    vidId: "VzJ1DwpLckw",
    desc: "Accessible Israel Webinar",
    category: "general",
  },
  {
    imgVideo: "Resources/Webinars/10.jpg",
    vidId: "yNMRHfE7KY8",
    desc: "Sustainability in Israel on the Birthday of the Trees",
    category: "general",
  },
  {
    imgVideo: "Resources/Webinars/9.jpg",
    vidId: "yuLPwY0ue5Q",
    desc: "Home of the Holidays",
    category: "general",
  },
  {
    imgVideo: "Resources/Webinars/1.jpg",
    vidId: "KC44gauVfRs",
    desc: "Israel for Every Generation",
    category: "mice",
  },
  // {
  //   imgVideo: "Resources/Webinars/2.jpg",
  //   vidId: "ZsOYCxgBSvw",
  //   desc: "Museum Madness - Monument Monday",
  //   category: "mice",
  // },
  // {
  //   imgVideo: "Resources/Webinars/3.jpg",
  //   vidId: "VQVkItpZ9eM",
  //   desc: "Museum Madness - Tapestry Tuesday",
  //   category: "mice",
  // },
  // {
  //   imgVideo: "Resources/Webinars/4.jpg",
  //   vidId: "iCWCTz5aMM0",
  //   desc: "Museum Madness - Wondrous Wednesday",
  //   category: "mice",
  // },
  // {
  //   imgVideo: "Resources/Webinars/7.jpg",
  //   vidId: "0dwfMjRjrMY",
  //   desc: "Museum Madness - Thoughtful Thursday",
  //   category: "mice",
  // },
  {
    imgVideo: "Resources/Webinars/8.jpg",
    vidId: "08Kw2Yy1MTw",
    desc: "A Sip of Israel Wine Webinar",
    category: "mice",
  },
  {
    imgVideo: "Resources/Webinars/5.jpg",
    vidId: "VzJ1DwpLckw",
    desc: "Accessible Israel Webinar",
    category: "mice",
  },
  {
    imgVideo: "Resources/Webinars/10.jpg",
    vidId: "yNMRHfE7KY8",
    desc: "Sustainability in Israel on the Birthday of the Trees",
    category: "mice",
  },
  {
    imgVideo: "Resources/Webinars/9.jpg",
    vidId: "yuLPwY0ue5Q",
    desc: "Home of the Holidays",
    category: "mice",
  },
];

export const AccomodationsData = [
  {
    imgVideo: "Accomodations/telaviv.jpg",
    desc: "Tel Aviv hotel association",
    href: "https://www.visit-tel-aviv.com/en/hotels-results/",
  },
  {
    imgVideo: "Accomodations/jerusalem.jpg",
    desc: "Jerusalem hotel association",
    href: "https://en.jerusalem-hotels.org.il/",
  },
  {
    imgVideo: "Accomodations/deadsea.jpg",
    desc: "Dead Sea hotel association",
    href: "http://www.deadsea-hotels.com/dead_sea_hotels.htm",
  },
  {
    imgVideo: "Accomodations/eilat.jpg",
    desc: "Eilat hotel association",
    href: "http://www.eilathotels.org.il/",
  },
  // {
  //   imgVideo: "Accomodations/tiberia.jpg",
  //   desc: "Tiberias hotel association",
  //   href: "https://www.visit-tiberias.com/?language=eng",
  // },
  // {
  //   imgVideo: "Accomodations/kibbutz_.jpg",
  //   desc: "The kibutz hotels chain",
  //   href: "https://www.booking-kibbutz.com/",
  // },
  {
    imgVideo: "Accomodations/youthhostel_.jpg",
    desc: "Youth Hostel",
    href:
      "https://en.iyha.org.il/?_ga=2.246768390.360016895.1660482022-173111834.1660482022",
  },
];

export const PromoMaterialsDataOLD = [
  {
    imgVideo: "Resources/PromoMaterials/1.jpg",
    vidId: "B83nmCSwRuw",
    desc: "The Holy Land Magazine 2018 Christian Tourism to Israel",
    href: "http://www.holylandmagazine.com/2018/mobile/index.html",
    category: "christian",
  },
  {
    imgVideo: "Resources/PromoMaterials/2.jpg",
    vidId: "03SZOb5G3vs",
    desc: "The Holy Land Magazine 2020 Christian Tourism to Israel",
    href: "http://www.holylandmagazine.com/",
    category: "christian",
  },
  {
    imgVideo: "Resources/PromoMaterials/3.jpg",
    vidId: "B83nmCSwRuw",
    desc: "Israel Nature And Parks Authority",
    href:
      "https://agents.israel.travel/assets/img/ResourcesPdf/PromoMaterials/General/Brochure_tayarut_English.pdf",
    category: "general",
  },
  // {
  //   imgVideo: "Resources/PromoMaterials/4.jpg",
  //   vidId: "03SZOb5G3vs",
  //   desc: "Map's Name XXXXXXXXXXXXXX",
  //   href: "Resources/PromoMaterials/href/1.pdf",
  //   category: "christian",
  // },
  // {
  //   imgVideo: "Resources/PromoMaterials/5.jpg",
  //   vidId: "B83nmCSwRuw",
  //   desc: "Map's Name XXXXXXXXXXXXXX",
  //   href: "Resources/PromoMaterials/href/1.pdf",
  //   category: "christian",
  // },
  // {
  //   imgVideo: "Resources/PromoMaterials/6.jpg",
  //   vidId: "03SZOb5G3vs",
  //   desc: "Materials XXXXXXXXXXXXXX",
  //   href: "Resources/PromoMaterials/href/1.pdf",
  //   category: "christian",
  // },
];

export const PromoMaterialsData = [
  {
    href: "https://www.flickr.com/photos/israelphotogallery/albums",
    image: "Resources/PromoMaterials/icons/Images-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Images-white.svg",
    text: "images",
    category: "general",
  },
  {
    href: "https://www.youtube.com/@goisraelofficial",
    image: "Resources/PromoMaterials/icons/VIDEOS-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/VIDEOS-white.svg",
    text: "videos",
    category: "general",
  },
  {
    href: "https://brochures.goisrael.com/",
    image: "Resources/PromoMaterials/icons/Brochures-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Brochures-white.svg",
    text: "brochures",
    category: "general",
  },
  {
    href: "https://agents.israel.travel/brochure.pdf",
    image: "Resources/PromoMaterials/icons/Icon_MoreBlue.svg",
    imageHover: "Resources/PromoMaterials/icons/Icon_MoreWhite.svg",
    text: "more",
    category: "general",
  },
  {
    href: "https://www.flickr.com/photos/israelphotogallery/albums",
    image: "Resources/PromoMaterials/icons/Images-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Images-white.svg",
    text: "images",
    category: "jewish",
  },
  {
    href: "https://www.youtube.com/@goisraelofficial",
    image: "Resources/PromoMaterials/icons/VIDEOS-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/VIDEOS-white.svg",
    text: "videos",
    category: "jewish",
  },
  {
    href: "https://brochures.goisrael.com/",
    image: "Resources/PromoMaterials/icons/Brochures-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Brochures-white.svg",
    text: "brochures",
    category: "jewish",
  },
  {
    href: "https://www.flickr.com/photos/israelphotogallery/albums",
    image: "Resources/PromoMaterials/icons/Images-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Images-white.svg",
    text: "images",
    category: "mice",
  },
  {
    href: "https://www.youtube.com/@goisraelofficial",
    image: "Resources/PromoMaterials/icons/VIDEOS-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/VIDEOS-white.svg",
    text: "videos",
    category: "mice",
  },
  {
    href: "https://brochures.goisrael.com/",
    image: "Resources/PromoMaterials/icons/Brochures-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Brochures-white.svg",
    text: "brochures",
    category: "mice",
  },
  {
    href: "https://www.flickr.com/photos/israelphotogallery/albums",
    image: "Resources/PromoMaterials/icons/Images-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Images-white.svg",
    text: "images",
    category: "christian",
  },
  {
    href: "https://www.youtube.com/@goisraelofficial",
    image: "Resources/PromoMaterials/icons/VIDEOS-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/VIDEOS-white.svg",
    text: "videos",
    category: "christian",
  },
  {
    href: "https://brochures.goisrael.com/",
    image: "Resources/PromoMaterials/icons/Brochures-blue.svg",
    imageHover: "Resources/PromoMaterials/icons/Brochures-white.svg",
    text: "brochures",
    category: "christian",
  },
  {
    href: "https://holyland.israel.travel/Pages/Resources",
    image: "Resources/PromoMaterials/icons/Icon_MoreBlue.svg",
    imageHover: "Resources/PromoMaterials/icons/Icon_MoreWhite.svg",
    text: "more",
    category: "christian",
  },
];
export const RelateOrganizationsData = [
  {
    href: "https://israeltravel.co.il/",
    name: "israeltravel.co.il",
    category: "christian",
  },
  {
    href: "https://holyland.israel.travel/",
    name: "holyland.israel.travel",
    category: "christian",
  },
  {
    href: "https://touroperatorspromotingisrael.com/",
    name: "promotingisrael.com",
    category: "christian",
  },
  {
    href: "https://en.parks.org.il/map/",
    name: "en.parks.org.il/map",
    category: "christian",
  },
  {
    href: "https://www.cicts.org/en",
    name: "www.cicts.org",
    category: "christian",
  },
  {
    href: "https://israel.travel/",
    name: "israel.travel",
    category: "christian",
  },
  {
    href: "https://www.israel21c.org/topic/travel/",
    name: "israel21c.org",
    category: "jewish",
  },
  {
    href: "https://en.parks.org.il/map",
    name: "en.parks.org.il",
    category: "jewish",
  },
  {
    href: "//searchisrael.vibeisrael.com",
    name: "searchisrael.vibeisrael.com",
    category: "jewish",
  },
  {
    href: "//unboxingisrael.vibeisrael.com",
    name: "unboxingisrael.vibeisrael.com",
    category: "jewish",
  },
  {
    href: "https://www.fromthegrapevine.com/",
    name: "fromthegrapevine.com",
    category: "jewish",
  },
  {
    href: "https://www.jnf.org/menu-2/our-work/heritage-site-preservation",
    name: "www.jnf.org",
    category: "jewish",
  },

  {
    href: "https://embassies.gov.il/pages/israelimissionsaroundtheworld.aspx",
    name: "embassies.gov.il",
    category: "jewish",
  },
  {
    href: "https://israel.travel/",
    name: "israel.travel",
    category: "jewish",
  },
  {
    href: "https://www.iccaworld.org/",
    name: "ICCA",
    category: "mice",
  },
  {
    href: "https://www.unwto.org/",
    name: "UNWTO",
    category: "mice",
  },

  {
    href: "https://www.cvb-tel-aviv.com/",
    name: "Tel Aviv Convention Bureau",
    category: "mice",
  },
  {
    href: "https://haifacvb.com/",
    name: "Haifa Convention Bureau ",
    category: "mice",
  },
  {
    href: "https://siteglobal.com/",
    name: "Site Global",
    category: "mice",
  },
  {
    href: "http://jerusalemcvb.com/",
    name: "Jerusalem Conventions & Visitors Bureau",
    category: "mice",
  },
  {
    href: " https://www.pcma.org/",
    name: "PCMA",
    category: "mice",
  },

  {
    href: "https://israeltravel.co.il/",
    name: "israeltravel.co.il",
    category: "general",
  },
  {
    href: "https://holyland.israel.travel/",
    name: "holyland.israel.travel",
    category: "general",
  },
  {
    href: "https://touroperatorspromotingisrael.com/",
    name: "promotingisrael.com",
    category: "general",
  },
  {
    href: "https://en.parks.org.il/map/",
    name: "en.parks.org.il/map",
    category: "general",
  },
  {
    href: "https://www.israel21c.org/topic/travel/",
    name: "israel21c.org",
    category: "general",
  },
  {
    href: "https://en.parks.org.il/map",
    name: "en.parks.org.il",
    category: "general",
  },
  {
    href: "//searchisrael.vibeisrael.com",
    name: "searchisrael.vibeisrael.com",
    category: "general",
  },
  {
    href: "//unboxingisrael.vibeisrael.com",
    name: "unboxingisrael.vibeisrael.com",
    category: "general",
  },
  {
    href: "https://www.fromthegrapevine.com/",
    name: "fromthegrapevine.com",
    category: "general",
  },
  {
    href: "https://www.jnf.org/menu-2/our-work/heritage-site-preservation",
    name: "www.jnf.org",
    category: "general",
  },
  {
    href: "https://embassies.gov.il/pages/israelimissionsaroundtheworld.aspx",
    name: "embassies.gov.il",
    category: "general",
  },
  {
    href: "https://israel.travel/",
    name: "israel.travel",
    category: "general",
  },
];

export const TestimonialsData = [
  {
    vidId: "B83nmCSwRuw",
    desc:
      "Textextt text text text Textextt text text text  Textextt text text text ",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/1.jpg",
  },
  {
    vidId: "03SZOb5G3vs",
    desc: "Text text text text text Textextt text text text ",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/2.jpg",
  },
  {
    vidId: "B83nmCSwRuw",
    desc: "Text text text text text",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/3.jpg",
  },
  {
    vidId: "03SZOb5G3vs",
    desc: "Text text text text text",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/4.jpg",
  },
  {
    vidId: "B83nmCSwRuw",
    desc: "Text text text text text",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/5.jpg",
  },
  {
    vidId: "B83nmCSwRuw",
    desc: "Text text text text text",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/5.jpg",
  },
  {
    vidId: "B83nmCSwRuw",
    desc: "Text text text text text",
    name: "Maurico Alfonso Guizar",
    country: "Mexico",
    imgVideo: "Resources/Testimonials/5.jpg",
  },
];

export const btnNames = [
  {
    name: "Home",
    classIs: "nav-home",
  },
  {
    name: "About",
    classIs: "nav-about",
  },
  {
    name: "Contact",
    classIs: "nav-contact",
  },
  {
    name: "Products",
    classIs: "nav-products",
  },
  {
    name: "Research",
    classIs: "nav-research",
  },
];

// start showsArr

// export const showsArr = [

//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
//         css_class: "unic-singer-Pride_Parade_2020",
//         id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.20",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         id: "Nickcave_Badseeds",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Hutzot Hayotzer Jerusalem",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Jerusalem March",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },

//       // Double posts for complite the SHOS carousel in mobile
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         isDouble: true,
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         isDouble: true,
//         book_now : "READ MORE"
//       },
//       // END Double posts for complite the SHOS carousel in mobile

//       /*----------------OLD SINGERS------------------*/

//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Read More"
//       },

//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Read More"
//       },

//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Read More"
//       },

//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Read More"
//       },

//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Read More"
//       },

//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Read More"
//       },

//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Read More"
//       },

//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Read More"
//       },

//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Read More"
//       },

//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Read More"
//       },

//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Read More"
//       },

//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Read More"
//       },

//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Read More"
//       },

//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Read More"
//       },

//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Read More"
//       },

//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Read More"
//       },

//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Read More"
//       },

//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "READ MORE"
//       },

//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "READ MORE"
//       },

//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "READ MORE"
//       },

//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: "/Posts/index.php?postType=concerts&post=94",
//         css_class: "unic-singer-inter-arts",
//         id: "The_International_Arts",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=91",
//         css_class: "unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=96",
//         css_class: "unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img: "Concerts/71.jpg",
//         side_img: "Concerts/72.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         book_now : "READ MORE"
//       },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-dgtl2019",
//         id: "DGTL_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=98",
//         css_class: "unic-singer-tlv-nightrun2019",
//         id: "Night_Run_TelAviv",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: "/Posts/index.php?postType=concerts&post=71",
//         css_class: "unic-singer-71",
//         book_now : "READ MORE"
//       },

//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tel Aviv Marathon",
//         desc: "",
//         date: "28.02.20",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Purim 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },

//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.20",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },
//       // {
//       //   title: "The Rubinstein International Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "White Night",
//       //   desc: "",
//       //   date: "06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "unic-singer-white-night-2020",
//       //   id: "White_Night_2020",
//       //   book_now : "READ MORE"
//       // },

// ];

// End showsArr

export const showsArr = [];

export const faqData = [
  {
    id: 1,
    q: "Where can I find resources and tools to market Israel to my clients?",
    answer: `
     <p>The Israel Ministry of Tourism has numerous promotional assets that you can share with your clients. Please <a href="https://agents.israel.travel/#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">click here</a> to find our various tools to promote our destination.</p>
     `,
    isOpen: false,
  },
  {
    id: 2,
    q: "Where can I learn more about selling Israel?",
    answer: `
     <p>The Israel Ministry of Tourism regularly conducts training for travel advisors to help them sell our special destination. Click here to find our most recent webinars.</p>
     <br/>
     <p>You can contact one of the ministry’s national/regional office:</p>
     <p>
    <!-- <a target="_blank" rel="noopener" href="https://www.gov.il/he/departments/topics/tourist-and-travelers-info/govil-landing-page">https://info.goisrael.com/en/office-abroad</a>
     <br/>
     or
     <br/>-->
     <a target="_blank" rel="noopener" href="https://agents.israel.travel/Pages/ContactUs" style="text-decoration:underline">Click here</a>
     </p>
     `,
    isOpen: false,
  },
  {
    id: 3,
    q: "How can I find a DMC in Israel?",
    answer: `
     
     <p>
     Israel has many highly professional tour operators and service providers, please check out our “Find a Tour Operator/Hotel/Guide” section in this <a href="https://agents.israel.travel/#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">website</a>
     </p>

     `,
    isOpen: false,
  },

  {
    id: 4,
    q: "How can I find out about hotels in the different cities in Israel?",
    answer: `
     
     <p>
     Israel has a diverse selection of hotels across the country from high end legacy luxury brands to guest houses that can be found only in Israel. There is something for everyone in every area of the country. To get started on your search, please check out our “Find a Tour Operator/Hotel/Guide” section in this <a href="https://agents.israel.travel#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">website</a> 
      </p>
   
     `,
    isOpen: false,
  },

  {
    id: 5,
    q: "What types of travel packages can I offer in Israel?",
    answer: `
     
     <p>
     Israel offers many types of experiences to many types of travelers. In this website we highlighted main categories of travel, and you can browse and get informed about them. There are many other types of travel not listed, but very relevant, such as MICE, Voluntourism, bird watching and many more - to learn more please contact the Israel Government Tourism office in your country/region-
      </p>
      <p>
      <!--<a target="_blank" rel="noopener" href="https://www.gov.il/en/Departments/DynamicCollectors/tourists-offices-abroad-english?skip=0">Click here</a>
      <br/>
      or
      <br/>-->
      <a target="_blank" rel="noopener" href="https://agents.israel.travel/Pages/ContactUs" style="text-decoration:underline">Click here</a>
      </p>
     `,
    isOpen: false,
  },

  {
    id: 6,
    q: "How do I find a tour guide?",
    answer: `
     <p>
     Israel tour guides are renowned for their professionalism and are required to complete an 18 month training program comparable to a graduate degree. Almost any language is available. To find out more about guides please check out our “Find a Tour Operator/Hotel/Guide” section in this website 
     </p>
     <p>
     <a target="_blank" rel="noopener" href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" style="text-decoration:underline">Click here</a>
     </p>
     `,
    isOpen: false,
  },
  {
    id: 7,
    q:
      "What languages are spoken by service providers in Israel (guides, drivers, restaurants etc.)?",
    answer: `
     <p>
     Israel is an immigrant society with more than 70 ethnicities represented in its population. While English is widely spoken, Spanish, Russian, French are also quite common. German, Portuegese, Chinese and other language service providers can generally be confirmed upon request.
     </p>
     `,
    isOpen: false,
  },
  {
    id: 8,
    q:
      "Can my client stay in one city and travel daily to different sites and areas in Israel?",
    answer: `
     <p>
     Israel is a relatively small country, it takes about 5 hours to cross from North to South, and less than two hours to cross from East to West. Most tourism sights are within two hours drive from the main cities, so tourists can be based in Jerusalem, Tel Aviv, Haifa or other central cities and take daily excursions to the majority of sites. Many itineraries include staying half of the visit in one region and the other in another, which allows touring the entire country during one visit.
     </p>
     `,
    isOpen: false,
  },

  {
    id: 9,
    q:
      "My client has safety concerns about traveling in the Middle East after visiting Israel",
    answer: `
     <p>
     Israel is one of the safest countries in the world and gets excellent reviews on surveys and online rating websites. There are no limitations of traveling into Israel after visiting other countries, and now after the recent peace agreements with many countries in the Middle East, there are almost no restrictions of entry to other countries after visiting Israel. Please also look at our general FAQ section for some more information -
      </p>
      <p>
      <a target="_blank" rel="noopener" href="https://israel.travel/faq/" style="text-decoration:underline">Click here</a>
      </p>
     `,
    isOpen: false,
  },
  {
    id: 10,
    q: "I have questions about currency, visa types, health insurance etc.",
    answer: `
     <p>
     Please visit our general FAQ section which has information about all the general topics and matters regarding an tourist’s visit to Israel -
     <p>
     <a target="_blank" rel="noopener" href="https://israel.travel/faq/"  style="text-decoration:underline">Click here</a>
     </p>
     `,
    isOpen: false,
  },
];

export const faqData2 = [
  {
    id: 1,
    q: "Frequently Asked Questions about the COVID-19",
    answer: `
      <ol start="1">
        <li><strong>I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?</strong><br/>
           <ul>
               <li>
                  If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately enter self-isolation and call the 101 MDA Emergency Services Hotline for medical advice.
                <strong>
                  Do not go to an HMO clinic or emergency ward.
                </strong>
         
               </li>
           </ul>
        </li>
        <li><strong>When will Israel be open to incoming visitors again?</strong><br/>
           <ul>
               <li>
                At this moment there is not a known date in which Israel will be open to incoming visitors.
         
               </li>
           </ul>
        </li>
       
       
      </ol>
      `,
    isOpen: false,
  },
  {
    id: 2,
    q: "Are Tel Aviv And Jerusalem a Long Way Away? ",
    answer: `
      <p>
        On the contrary! It’s so much closer than you may think, just a quick 4-5 hours’ flight and you can enjoy the sunny beaches of Tel Aviv and the amazing sites of Jerusalem. Best of all, Tel Aviv and Jerusalem are only one hours’ drive away from one another.
      </p>
      `,
    isOpen: false,
  },

  {
    id: 3,
    q: "How do I get around in Tel Aviv and Jerusalem?",
    answer: `
      
      <p>
       The most convenient and popular means of transport in are buses, service taxis, and the national rail. Jerusalem also has convenient light rail service to most popular sites around the city. 
      </p>
      <p>
       For information regarding rail stations, routes and schedules, <a target="_blank" href="//www.rail.co.il">www.rail.co.il</a>
      </p>
      <p>
       For information regarding bus routes and schedules visit <a target="_blank" href="//www.bus.gov.il">www.bus.gov.il</a>  
      </p>
      <p>
       Public transport helpline <a href="tel:*8787">*8787</a>  
      </p>
      <p>
       Local public transport app - ‘Moovit’ 
      </p>
      <h4>
      Taxis 
      </h4>
      <p>
        Taxis for urban and interurban travel can be flagged in the street or booked via phone or designated apps such as Gett (GetTaxi). 
      </p>

      <h4>
      Sherut Taxis 
      </h4>
      <p>
         “Sherut” (service) taxis are 10 - 12 seater vans which generally follow major bus routes, in and between major cities. Pricewise, sherut taxi fares have a set price, similar to public bus fares.
      </p>

      <h4>
      Car Rental 
      </h4>
      <p>
        Most car rental services in Central Tel Aviv can be found along Hayarkon Street, near the Tel Aviv beachfront and in hotel areas in most other major cities.
      </p>

      <h4>
      Tel-O-Fun 
      </h4>
      <p>
        Tel-O-Fun is a bicycle sharing service provided by city of Tel Aviv and available for residents and tourists alike. The Tel-O-Fun service has 2,000 bicycles at 200 stations allowing you to rent a bike and ride along 130 Km of designated riding lanes. You can purchase a daily or weekly access card using a credit card at any one of the rental station terminals.
      </p>
      .
      `,
    isOpen: false,
  },

  {
    id: 4,
    q: "What About Money?",
    answer: `
      <p>
        The Israeli currency is the Shekel. Cash withdrawals can be made via ATMs at banks throughout the city.  Private ATMs are also available in local kiosks,  charging a commission of 5.90-7.90 NIS per withdrawal. Exchange services can be found in private 
        commission-free change offices in tourist areas, usually open until late. Of course, credit cards are widely accepted.  Western Union operates within most post offices, offering money transfer services. 
      </p>
      `,
    isOpen: false,
  },

  {
    id: 5,
    q: "Staying Connected",
    answer: `

        <h4>
          Phone Services
        </h4>
        <p>
          Should you wish, you can buy a local SIM card from a phone store or city information center and pay-as-you-go vouchers at many small convenience stores 
          and currency exchange booths.
        </p>

        <h4>
          Hotspots – Free WIFI
        </h4>
        <p>
          Tel Aviv prides itself on being a cutting-edge, smart city. Free WIFI is available for your convenience in 80 different locations around the city (including the beach, entertainment centers, and most tourist areas). 
        </p>
        <p>
          In Jerusalem, free WIFI areas can be found at train stations, universities, museums, visitors centers, convention halls, tourism sites and shopping malls and also at the local Tourist Information Center.
        </p>

      `,
    isOpen: false,
  },

  {
    id: 6,
    q: "What’s the weather like? ",
    answer: `
        <p>
        The weather in Tel Aviv is warm and lovely most year-round, the summers are long and perfect for the beach and touring around, while the winters are friendly without much rainfall. Winter Average: 9-17ºC. Summer Average: 24-30ºC.
        
        </p>
        <p>
          Jerusalem enjoys long sunny summers (May-September) and winters (November-March) which can get very cold and rainy with the occasional snowstorm, and temperatures sometimes down to freezing. 
          For current information visit the Israeli Meteorological Service: <a target="_blank" href="//www.ims.gov.il">www.ims.gov.il</a>

        </p>
      `,
    isOpen: false,
  },

  {
    id: 7,
    q: "Are working hours different?",
    answer: `
        
        <p>
           Yep, workdays are Sundays through Thursdays while the Weekend is Fridays and Saturdays. Most businesses are open on Fridays until the early afternoon, before the onset of the Jewish Shabbat, which begins at sundown on Friday and lasts until shortly after sundown on Saturday.  <a target="_blank" href="//www.timeanddate.com/worldclock/Israel">www.timeanddate.com/worldclock/Israel</a>
        </p>
      `,
    isOpen: false,
  },
];

export const newPosts = [
  {
    title: "2 AWESOME CITIES",
    // "sml_desc": "One magical unforgettable getaway to the sun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    vidId: "b0QexDxEklA",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },
  {
    title: "JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Jerusalem",
  },
  {
    title: "Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tel_Aviv",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Tel_Aviv",
  },
  {
    title: "The Dead Sea",
    // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/next-level.jpg",
    side_img: "/PostCarousel/DeadSea/next-level.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Next_Level_DS",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Next_Level_DS",
  },
  {
    title: "MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Masada",
  },
  {
    title: "Jerusalem’s Old City",
    sml_desc: "",
    // "sml_desc": "Jerusalem’s Old City",
    desc: "",
    // "desc": "Sensational sites of Ancient Times",
    img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Old_City",
    isVid: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Jerusalem_Old_City",
  },
  {
    title: "NATURE'S GLORY",
    // "sml_desc": "THE DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natures_Glory",
    isVid: true,
    vidId: "M627s8TdaB8",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "deadsea",
    id: "Natures_Glory",
  },

  {
    title: "ALL SENSORY MARKETS",
    sml_desc: "",
    desc: "",
    img: "thingsToDo/8.jpg",
    side_img: "thingsToDo/sidebar/8.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: "All_Sensory_Markets",
    showOnHome: false,
    ctg: "jerusalem",
  },
  {
    title: "THE DEAD SEA NATURAL SPA",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "deadsea",
    id: "Natural_Spa",
  },

  // This post is double for complitting the JERUSALEM carousel in mobile
  {
    title: "MUST EAT IN JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "jerusalem",
    id: "Must_Eat_In_Jerusalem",
  },
  // END This post is double for complitting the JERUSALEM carousel in mobile

  {
    title: "Amazing Nightlife",
    sml_desc: "",
    // "sml_desc": "Amazing Nightlife",
    desc: "",
    // "desc": "It’s a never-ending party<br> in the nonstop city!",
    img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    side_img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    id: "Amazing_Nightlife",
  },

  {
    title: "Upscale Jerusalem",
    // "sml_desc": "Modern luxuries for the pampered traveler",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/45.jpg",
    side_img: "/PostCarousel/Jerusalem/45.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=45",
    isVid: false,
    isDouble: false,
    ctg: "jerusalem",
    id: 45,
  },
  {
    title: "NATURAL PHENOMENA",
    // "sml_desc": "THE DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    side_img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Phenomena",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "deadsea",
    id: "Natural_Phenomena",
  },
  {
    title: "Jerusalem ‘Musts’",
    // "sml_desc": "5 things to do in the stunning city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: true,
    isDouble: false,
    vidId: "k4OwoEk5wMw",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },
  {
    // "title": "A Foodie’s Paradise‘",
    title: "Simply Delicious",
    // "sml_desc": "Check out Tel Aviv’s \n awesome culinary Scene",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/99.jpg",
    img_mob: "/PostCarousel/video_mob/99.jpg",
    side_img: "/PostCarousel/99.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=21",
    ctg: "culinarytelaviv",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    isDouble: false,
    id: "Simply_Delicious",
  },
  {
    title: "Cool Jerusalem",
    // "sml_desc": "A city beyond expectations",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cool Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    id: "Cool_Jerusalem",
  },
  {
    title: "THE MAGICAL DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },

  {
    title: "Market Madness",
    // "sml_desc": "Market Madness",
    sml_desc: "",
    // "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
    desc: "",
    img: "Videos/market-madness.jpg",
    img_mob: "/Videos/video_mob/market-madness.jpg",
    side_img: "Videos/sidebar/market-madness.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Market_Madness",
    vidId: "2CSCe2WC7Ns",
    ctg: "jerusalem",
    isVid: true,
    isDouble: false,
    id: "Market_Madness",
  },

  // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"
  {
    title: "Looking for a crazy nightlife?",
    // "sml_desc": " Book your trip to Tel Aviv!",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/crazy-night.jpg",
    img_mob: "/Videos/video_mob/crazy-night.jpg",
    side_img: "Videos/sidebar/crazy-night.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    vidId: "ogEN7aRT0SM",
    ctg: "telaviv",
    isDouble: false,
    isVid: true,
    id: "Amazing_Nightlife",
  },
  // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"
  {
    title: "Jaffa Port ",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    side_img: "/PostCarousel/TelAviv/jaffa-port.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: false,
    isDouble: false,
    ctg: "telaviv",
    id: "Port_Pleasures",
  },
  {
    title: "Go To Guide",
    // "sml_desc": "Travel from Tel Aviv and Jerusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/34.jpg",
    side_img: "/PostCarousel/34.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=35",
    ctg: "telaviv",
    isVid: false,
    isDouble: false,
    // "id": 35
    id: "Go_To_Guide",
  },

  {
    title: "JERUSALEM",
    // "sml_desc": "THE HEART OF THE WORLD",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    isDouble: false,
    id: "Heart_Of_The_World",
  },
  {
    title: "Tel-Aviv Highlights",
    // "sml_desc": "Top 5 things to see and\n do in the city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/17.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    vidId: "LLOUxE-K_9Y",
    isVid: true,
    isDouble: false,
    // "isVid": false,
    forVidPage: true,
    id: "Tel-Aviv_Highlights",
  },
  {
    title: "First Time in Jerusalem",
    // "sml_desc": "The must list for the first time visitor",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=First_Time_In_Jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "jerusalem",
    id: "First_Time_In_Jerusalem",
  },
  {
    title: "Boutique Hospitality",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    side_img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Boutique_Hospitality",
    isVid: false,
    ctg: "telaviv",
    isDouble: false,
    id: "Boutique_Hospitality",
  },
  {
    title: "A taste of Jerusalem",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "culinaryjerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    isDouble: false,
    id: "A_Taste_Of_Jerusalem",
  },
  {
    title: "Coffee in Tel Aviv",
    // "sml_desc": "Tel Aviv over a fresh coffee",
    sml_desc: "",
    // "desc": "Coffee shop culture is fundamental",
    desc: " ",
    img: "Videos/coffee.jpg",
    img_mob: "/Videos/video_mob/coffee.jpg",
    side_img: "Videos/sidebar/coffee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=16",
    vidId: "rVr0gqFC364",
    ctg: "culinarytelaviv",
    isVid: true,
    isDouble: false,
    id: "Coffee_In_TelAviv",
  },

  {
    title: "Sectrets of jewish Jerusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/secrets-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/secrets-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
    isVid: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Sectrets_Of_Jewish_Jerusalem",
  },
  {
    title: "Non Stop Markets",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/non-stop-markets.jpg",
    side_img: "/PostCarousel/TelAviv/non-stop-markets.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Non_Stop_Markets",
    isVid: false,
    ctg: "telaviv",
    isDouble: false,
    id: "Non_Stop_Markets",
  },
  {
    title: "MAMILLA AVENUE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },
  {
    title: "Joys of Jaffa",
    sml_desc: "",
    // "sml_desc" : "Ancient, Artsy and Fabulous",
    desc: "",
    // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
    img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    side_img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Joys_Of_Jaffa",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    id: "Joys_Of_Jaffa",
  },
  {
    title: "TOWER OF DAVID MUSEUM",
    sml_desc: "",
    img: "thingsToDo/7.jpg",
    side_img: "thingsToDo/sidebar/7.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    id: "Tower_Of_David_Museum",
    showOnHome: false,
    isDouble: false,
    ctg: "jerusalem",
  },
  {
    title: "TEL AVIV BY THE SEA",
    // "sml_desc": "Cause life’s a beach in Tel Aviv ",
    sml_desc: "",
    // "desc": "Get ready for some serious fun",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "XDei1Zy_cu4",
    ctg: "telaviv",
    isVid: true,
    isDouble: false,
    id: "TelAviv_By_The_Sea",
  },
  {
    title: "JERUSALEM’S ART",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem-art.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-art.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Arts",
    isVid: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Jerusalem_Arts",
  },
  {
    title: "Neve Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic and Unique  ",
    // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "READ MORE",
    vidId: "5jl13Z-38eE",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    isDouble: false,
    id: "Neve_Tzedek",
  },
  {
    title: "MUST EAT IN JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    isVid: true,
    isDouble: false,
    vidId: "2CSCe2WC7Ns",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Must_Eat_In_Jerusalem",
  },
  {
    title: "Tel Aviv Vegan Scene",
    // "sml_desc": "Voted # 1 Vegan destination in the world  ",
    // "desc": "Enjoy the huge choice of vegan",
    sml_desc: "",
    desc: "",
    img: "Videos/h.jpg",
    img_mob: "/Videos/video_mob/h.jpg",
    side_img: "Videos/sidebar/h.jpg",
    vidId: "prLvetkAWwg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=6",
    ctg: "culinarytelaviv",
    isVid: true,
    isDouble: false,
    id: "Vegan_Friendly_TelAviv",
  },
  {
    title: "Shopping Delights",
    // "sml_desc": "From culture to souvenirs",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/5.jpg",
    side_img: "/PostCarousel/5.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Shopping_Delights",
    ctg: "jerusalem",
    // "isVid": false,
    isVid: true,
    isDouble: false,
    vidId: "MXtcTm_JXus",
    forVidPage: true,
    id: "Shopping_Delights",
  },
  {
    title: "Tel Aviv Adventures",
    // "sml_desc": "Cool things to do in the hot city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/40.jpg",
    side_img: "/PostCarousel/40.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=TelAviv_Adventures",
    ctg: "telaviv",
    isVid: false,
    isDouble: false,
    id: "TelAviv_Adventures",
  },
  {
    title: "UNFORGETTABLE YAD VASHEM",
    sml_desc: "",
    img: "thingsToDo/10.jpg",
    side_img: "thingsToDo/sidebar/10.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: 31,
    showOnHome: false,
    ctg: "jerusalem",
  },
  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "A huge selection of attractions  <br/> in a stunningly renovated Templar colony",
    // "sml_desc": "A stunning urban oasis",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=Sarona_TelAviv",
    vidId: "AcjsyamDZL8",
    ctg: "telaviv",
    isVid: true,
    isDouble: false,
    id: "Sarona_TelAviv",
  },
  {
    title: "THE GATES OF JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gates.jpg",
    side_img: "/PostCarousel/Jerusalem/gates.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    isVid: true,
    isDouble: false,
    vidId: "MXtcTm_JXus",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "The_Gates_Of_Jerusalem",
  },
  {
    title: "Day isTrippin’",
    sml_desc: "",
    // "sml_desc" : "Day isTrippin’",
    desc: "",
    // "desc" : "Fabulous and fascinating one day in Tel Aviv",
    img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    side_img: "/PostCarousel/TelAviv/day-is-trippin.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Day_IsTrippin",
    isVid: false,
    isDouble: false,
    ctg: "telaviv",
    id: "Day_IsTrippin",
  },
  {
    title: "Discover the Wine Routes",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/discover-the-wine-routes.jpg",
    img_mob: "/PostCarousel/video_mob/discover-the-wine-routes.jpg",
    side_img: "/PostCarousel/discover-the-wine-routes.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Discover_The_Wine_Routes",
    css_class: "unic-post-discover-the-wine-routes",
    isVid: true,
    isDouble: false,
    vidId: "Cxii1yKqKwI",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinarynorth",
    id: "Discover_The_Wine_Routes",
  },
  {
    title: "JERUSALEM MAIN SITES",
    // "sml_desc": "Travel back thousands of years",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=9",
    isVid: true,
    isDouble: false,
    vidId: "k4OwoEk5wMw",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Main_Sites",
  },
  {
    title: "GOURMET TEL AVIV",
    // "sml_desc": "The perfect place\n to treat yourself",
    sml_desc: "",
    // "desc": "Tel Aviv's huge variety of amazing",
    desc: "",
    img: "Videos/gourmet-telaviv.jpg",
    img_mob: "/Videos/video_mob/gourmet-telaviv.jpg",
    side_img: "Videos/sidebar/gourmet-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=33",
    vidId: "jfyHxk8ZRrI",
    ctg: "culinarytelaviv",
    isVid: true,
    isDouble: false,
    id: "Gourmet_TelAviv",
  },
  {
    title: "WESTERN WALL WONDERS",
    sml_desc: "",
    img: "thingsToDo/4.jpg",
    side_img: "thingsToDo/sidebar/4.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Western_Wall_Wonders",
    css_class: "unic_video-post-Western_Wall_Wonders",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: "Western_Wall_Wonders",
    ctg: "jerusalem",
    showOnHome: false,
  },
  {
    title: "Travelling on a Budget",
    // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/44.jpg",
    side_img: "/PostCarousel/44.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=44",
    isVid: false,
    isDouble: false,
    ctg: "telaviv",
    id: 44,
  },
  {
    title: "PURCHASES IN ISRAEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/unique.jpg",
    side_img: "/PostCarousel/Jerusalem/unique.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Purchases_In_Israel",
    isVid: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Purchases_In_Israel",
  },
  {
    title: "Tel Aviv street food",
    // "sml_desc" : "Tel Aviv street food",
    sml_desc: "",
    // "desc" : "A true world-class foodie destination",
    desc: "",
    img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tel_Aviv_Street_Food",
    isVid: true,
    isDouble: false,
    vidId: "JQD9JpMaw9g",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Tel_Aviv_Street_Food",
  },
  {
    title: "JERUSALEM FUN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Fun",
    isVid: true,
    isDouble: false,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Fun",
  },
  {
    title: "Cycle Tel Aviv",
    // "desc": "Get on your bicycle -<br> explore the city in style",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "telaviv",
    isVid: true,
    isDouble: false,
    vidId: "88OV6xU0vPI",
    // "isVid": false,
    forVidPage: true,
    id: "Cycle_TelAviv",
  },

  {
    title: "ULTIMATE BEACH FUN",
    sml_desc: "",
    // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    desc: "",
    img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    img_mob: "/PostCarousel/video_mob/ultimate-beaches.jpg",
    side_img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=24",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: "Ultimate_Beach_Fun",
    ctg: "telaviv",
    showOnHome: false,
  },
  {
    title: "Modern and Vibrant",
    // "sml_desc": "So much to see in Jerusalem’s",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Modern_And_Vibrant",
    isVid: true,
    isDouble: false,
    vidId: "MXtcTm_JXus",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Modern_And_Vibrant",
  },
  {
    title: "WHITE CITY SPLENDOR",
    sml_desc: "",
    desc: "",
    img: "thingsToDo/6.jpg",
    side_img: "thingsToDo/sidebar/6.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    // "isVid": false,
    id: "White_City_Splendor",
    showOnHome: false,
    ctg: "telaviv",
  },
  {
    title: "Jerusalem after dark fun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    side_img: "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    isVid: true,
    isDouble: false,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_After_Dark_Fun",
  },
  {
    title: "Enjoy and Indulge",
    // "sml_desc": "Enjoy and Indulge",
    sml_desc: "",
    // "desc": "Tel Aviv - The ultimate luxury destination",
    desc: "",
    img: "/PostCarousel/36.jpg",
    side_img: "/PostCarousel/36.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=37",
    ctg: "telaviv",
    isDouble: false,
    isVid: false,
    id: 37,
  },
  {
    title: "Sensational Beaches",
    // "sml_desc": "Come chill by the sunny beaches",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    side_img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=14",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    //"id": 14
    id: "Sensational_Beaches",
  },

  //Hadar asked to hide the video in this post on 18.01.2021
  {
    title: "Non Stop Culture",
    // "sml_desc": "Non Stop Culture",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/culture-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Non_Stop_Culture",
    isVid: false,
    vidId: "MXtcTm_JXus",
    // "isVid": false,
    ctg: "telaviv",
    forVidPage: false,
    isDouble: false,
    id: "Non_Stop_Culture",
  },
  //End Hadar asked to hide the video in this post on 18.01.2021

  // {
  //     "title": "ALL SENSORY MARKETS",
  //     "sml_desc": "",
  //     "img": "thingsToDo/8.jpg",
  //     "side_img": "thingsToDo/sidebar/8.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": true,
  //     // "isVid": false,
  //     "id": "All_Sensory_Markets",
  //     "showOnHome": false,
  //     "ctg": "culinary"

  // },

  {
    title: "Jamie Oliver in Tel Aviv",
    // "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
    sml_desc: "",
    desc: "",
    img: "Videos/jamie-oliver.jpg",
    img_mob: "/Videos/video_mob/jamie-oliver.jpg",
    side_img: "Videos/sidebar/jamie-oliver.jpg",
    vidId: "gGe4W8WaIiQ",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jamie_Oliver",
    ctg: "culinarytelaviv",
    isVid: true,
    isDouble: false,
    id: "Jamie_Oliver",
  },

  {
    title: "Party Capital",
    // "sml_desc": "Epic Nights in the non stop city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/42.jpg",
    side_img: "/PostCarousel/42.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    id: "Party_Capital",
  },

  {
    title: "Nonstop Excitement",
    // "sml_desc": "unforgettable Tel Aviv ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: true,
    isDouble: false,
    vidId: "88OV6xU0vPI",
    // "isVid": false,
    forVidPage: true,
    id: "Nonstop_Excitement",
  },
  {
    title: "Port Pleasures ",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    side_img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  // Three posts for Tel aviv carousel mobile version
  {
    title: "TEL AVIV BY THE SEA",
    // "sml_desc": "Cause life’s a beach in Tel Aviv ",
    sml_desc: "",
    // "desc": "Get ready for some serious fun",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "XDei1Zy_cu4",
    ctg: "telaviv",
    isDouble: true,
    isVid: true,
    id: "TelAviv_By_The_Sea",
  },
  {
    title: "Boutique Hospitality",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    side_img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Boutique_Hospitality",
    isVid: false,
    isDouble: true,
    ctg: "telaviv",
    id: "Boutique_Hospitality",
  },

  {
    title: "ULTIMATE BEACH FUN",
    sml_desc: "",
    // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    desc: "",
    img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    img_mob: "/PostCarousel/video_mob/ultimate-beaches.jpg",
    side_img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=24",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: true,
    id: "Ultimate_Beach_Fun",
    ctg: "telaviv",
    showOnHome: false,
  },

  //  Three posts for CULINARY carousel mobile version
  {
    title: "A taste of Jerusalem",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "culinaryjerusalem",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    isDouble: true,
    id: "A_Taste_Of_Jerusalem",
  },
  {
    title: "Jamie Oliver in Tel Aviv",
    // "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
    sml_desc: "",
    desc: "",
    img: "Videos/jamie-oliver.jpg",
    img_mob: "/Videos/video_mob/jamie-oliver.jpg",
    side_img: "Videos/sidebar/jamie-oliver.jpg",
    vidId: "gGe4W8WaIiQ",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jamie_Oliver",
    ctg: "culinarytelaviv",
    isVid: true,
    isDouble: true,
    id: "Jamie_Oliver",
  },
  // END Three posts for CULINARY carousel mobile version

  // Three posts for DAED SEA carousel mobile version
  {
    title: "The Dead Sea",
    // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/next-level.jpg",
    side_img: "/PostCarousel/DeadSea/next-level.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Next_Level_DS",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Next_Level_DS",
  },
  {
    title: "NATURAL PHENOMENA",
    // "sml_desc": "THE DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    img_mob: "/PostCarousel/video_mob/natural-phenomena.jpg",
    side_img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Phenomena",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Natural_Phenomena",
  },

  // END Three posts for DEAD SEA carousel mobile version

  // END Three posts for NEGEV AND EILAT carousel mobile version
  {
    title: "EILAT ULTIMATE BEACHSIDE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },
  // END Three posts for NEGEV AND EILAT carousel mobile version

  // Eilat Posts
  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "EILAT1",
  },
  {
    title: "Welcome to Eilat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/welcome-to-eilat.jpg",
    side_img: "/PostCarousel/welcome-to-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Welcome_To_Eilat",
    css_class: "unic-post-welcome-to-eilat",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Welcome_To_Eilat",
  },
  {
    title: "THE ULTIMATE HOLIDAY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-ultimate-holiday.jpg",
    side_img: "/PostCarousel/the-ultimate-holiday.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Ultimate_Holiday",
    css_class: "unic-post-the-ultimate-holiday",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "The_Ultimate_Holiday",
  },
  {
    title: "EILAT’S CALLING",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-calling.jpg",
    side_img: "/PostCarousel/eilat-calling.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Calling",
    css_class: "unic-post-eilat-calling",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Eilat_Calling",
  },
  {
    title: "EILAT’S DOLPHIN REEF",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },
  {
    title: "Action Packed Eilat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-packed-eilat.jpg",
    side_img: "/PostCarousel/action-packed-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Packed_Eilat",
    css_class: "unic-post-action-packed-eilat",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Action_Packed_Eilat",
  },
  {
    title: "EILAT ULTIMATE BEACHSIDE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },
  {
    title: "One Day in Eilat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/one-day-in-eilat.jpg",
    side_img: "/PostCarousel/one-day-in-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=One_Day_In_Eilat",
    css_class: "unic-post-one-day-in-eilat",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "One_Day_In_Eilat",
  },
  {
    title: "ISRAEL’S MAJESTIC DESERT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/majestic-desert.jpg",
    side_img: "/PostCarousel/majestic-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Majestic_Desert",
    css_class: "unic-post-majestic-desert",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Majestic_Desert",
  },
  {
    title: "Negev",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev.jpg",
    side_img: "/PostCarousel/negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev1",
    css_class: "unic-post-negev",
    isVid: true,
    vidId: "yXzhH92kREg",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Negev1",
  },
  {
    title: "LOCATION AND APPROACH",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/location-and-approach.jpg",
    side_img: "/PostCarousel/location-and-approach.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Location_And_Approach",
    css_class: "unic-post-location-and-approach",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Location_And_Approach",
  },
  {
    title: "STAY IN THE NEGEV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/stay-in-the-negev.jpg",
    side_img: "/PostCarousel/stay-in-the-negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Stay_In_The_Negev",
    css_class: "unic-post-stay-in-the-negev",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Stay_In_The_Negev",
  },
  {
    title: "Pure Desert Magic",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/pure-desert-magic.jpg",
    side_img: "/PostCarousel/pure-desert-magic.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Pure_Desert_Magic",
    css_class: "unic-post-pure-desert-magic",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Pure_Desert_Magic",
  },
  {
    title: "ACTION FUN IN THE ISRAELI DESERT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: true,
    isDouble: false,
    vidId: "yXzhH92kREg",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "THE INCENSE ROUTE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: true,
    isDouble: false,
    vidId: "5AAqIhkq_tQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },
  {
    title: "Mount Karkom",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/mount-karkom.jpg",
    side_img: "/PostCarousel/mount-karkom.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mount_Karkom",
    css_class: "unic-post-mount-karkom",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Mount_Karkom",
  },
  {
    title: "Machtesh Ramon",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/machtes-ramon.jpg",
    side_img: "/PostCarousel/machtes-ramon.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Machtesh_Ramon",
    css_class: "unic-post-machtes-ramon",
    isVid: false,
    ctg: "eilat-negev",
    id: "Machtesh_Ramon",
  },
  {
    title: "Epic Masada",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: true,
    isDouble: false,
    vidId: "XxWa_MNm5x8",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },
  {
    title: "The Bedouin Experience",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-bedouin-experience.jpg",
    side_img: "/PostCarousel/the-bedouin-experience.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Bedouin_Experience",
    css_class: "unic-post-the-bedouin-experience",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "The_Bedouin_Experience",
  },
  {
    title: "Israel National Trail",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-israel-national-trail.jpg",
    side_img: "/PostCarousel/the-israel-national-trail.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Israel_National_Trail",
    css_class: "unic-post-the-israel-national-trail",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "The_Israel_National_Trail",
  },
  {
    title: "Timna Treasures",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: true,
    isDouble: false,
    vidId: "i_4QKtXIeto",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },
  {
    title: "NEGEV DESERT – DON’T MISS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-desert-dont-miss.jpg",
    side_img: "/PostCarousel/negev-desert-dont-miss.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Desert_Dont_Miss",
    css_class: "unic-post-negev-desert-dont-miss",
    isVid: false,
    isDouble: false,
    ctg: "eilat-negev",
    id: "Negev_Desert_Dont_Miss",
  },
  {
    title: "NEGEV CHARMS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-charms.jpg",
    side_img: "/PostCarousel/negev-charms.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Charms",
    css_class: "unic-post-negev-charms",
    isVid: true,
    isDouble: false,
    vidId: "3UddwPEzDXo",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Negev_Charms",
  },
  // End Eilat Posts

  // North Posts
  {
    title: "Galilee",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee.jpg",
    side_img: "/PostCarousel/galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee",
    css_class: "unic-post-galilee",
    isVid: true,
    isDouble: false,
    vidId: "5Ep3GgxELag",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee",
  },
  {
    title: "Caesarea",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea",
    css_class: "unic-post-caesarea",
    isVid: true,
    isDouble: false,
    vidId: "eLZ433_S6HI",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Caesarea",
  },
  {
    title: "Acre",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: true,
    isDouble: false,
    vidId: "KlXXyToCmCM",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  {
    title: "Haifa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: true,
    isDouble: false,
    vidId: "3ahATaKkhBk",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Haifa",
  },
  {
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: true,
    isDouble: false,
    vidId: "i3_ihL51bHo",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Safed",
  },
  {
    title: "THE STUNNING BAHA’I GARDENS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/bahai-gardens.jpg",
    side_img: "/PostCarousel/bahai-gardens.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Bahai_Gardens",
    css_class: "unic-post-bahai-gardens",
    isVid: true,
    isDouble: false,
    vidId: "JV_AmfRULOo",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "The_Bahai_Gardens",
  },
  {
    title: "The Sea of Galilee (Kinneret )",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/sea-of-galilee.jpg",
    side_img: "/PostCarousel/sea-of-galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Sea_Of_Galilee",
    css_class: "unic-post-sea-of-galilee",
    isVid: true,
    isDouble: false,
    vidId: "haG-t3wwuMc",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "The_Sea_Of_Galilee",
  },
  {
    title: "Rosh Pina",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/rosh-pina.jpg",
    side_img: "/PostCarousel/rosh-pina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Rosh_Pina",
    css_class: "unic-post-rosh-pina",
    isVid: true,
    isDouble: false,
    vidId: "_qKbHL5-qrQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Rosh_Pina",
  },

  {
    title: "Cheers to Israel",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/cheers-to-israel.jpg",
    img_mob: "/PostCarousel/video_mob/cheers-to-israel.jpg",
    side_img: "/PostCarousel/cheers-to-israel.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cheers_To_Israel",
    css_class: "unic-post-cheers-to-israel",
    isVid: true,
    isDouble: false,
    vidId: "Cxii1yKqKwI",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinarynorth",
    id: "Cheers_To_Israel",
  },

  {
    title: "A Galilean treat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilean-treat.jpg",
    img_mob: "/PostCarousel/video_mob/galilean-treat.jpg",
    side_img: "/PostCarousel/galilean-treat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=A_Galilean_Treat",
    css_class: "unic-post-galilean-treat",
    isVid: true,
    isDouble: false,
    vidId: "kF808ENuuTQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinarynorth",
    id: "A_Galilean_Treat",
  },

  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: true,
    isDouble: false,
    vidId: "1M7N5BcmjFM",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Nazareth",
  },

  {
    title: "GALILEE ACTION",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee-action.jpg",
    side_img: "/PostCarousel/galilee-action.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_Action",
    css_class: "unic-post-galilee-action",
    isVid: true,
    isDouble: false,
    vidId: "5Ep3GgxELag",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee_Action",
  },
  {
    title: "Bet She’an",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/bet-shean.jpg",
    side_img: "/PostCarousel/bet-shean.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Bet_Shean",
    css_class: "unic-post-bet-shean",
    isVid: false,
    isDouble: false,
    ctg: "north",
    id: "Bet_Shean",
  },

  {
    title: "Zichron Ya’akov",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/zichron-yaakov.jpg",
    side_img: "/PostCarousel/zichron-yaakov.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Zichron_Yaakov",
    css_class: "unic-post-zichron-yaakov",
    isVid: false,
    isDouble: false,
    ctg: "north",
    id: "Zichron_Yaakov",
  },
  {
    title: "Birdtastic Hula Lake",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/birdtastic-hula-lake.jpg",
    side_img: "/PostCarousel/birdtastic-hula-lake.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Birdtastic_Hula_Lake",
    css_class: "unic-post-birdtastic-hula-lake",
    isVid: true,
    vidId: "ImobrsxsKl8",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "north",
    id: "Birdtastic_Hula_Lake",
  },
  {
    title: "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/kibbutz-experience.jpg",
    side_img: "/PostCarousel/kibbutz-experience.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Kibbutz_Experience",
    css_class: "unic-post-kibbutz-experience",
    isVid: false,
    isDouble: false,
    ctg: "north",
    id: "The_Kibbutz_Experience",
  },
  {
    title: "NATIONAL PARKS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/national-parks.jpg",
    side_img: "/PostCarousel/national-parks.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=National_Parks",
    css_class: "unic-post-national-parks",
    isVid: false,
    isDouble: false,
    ctg: "north",
    id: "National_Parks",
  },

  {
    title: "Tiberias (Tverya)",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/tiberias.jpg",
    side_img: "/PostCarousel/tiberias.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tiberias",
    css_class: "unic-post-tiberias",
    isVid: false,
    isDouble: false,
    ctg: "north",
    id: "Tiberias",
  },
];

export const newVideos = [
  {
    title: "2 AWESOME CITIES",
    // "sml_desc": "One magical unforgettable getaway to the sun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    img_mob: "/PostCarousel/video_mob/tw-awesome-cities.jpg",
    side_img: "/PostCarousel/Jerusalem/tw-awesome-cities.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    vidId: "b0QexDxEklA",
    // "isVid": false,
    forVidPage: true,
    ctg: "telavivAndJerusalem",
    id: "2_AWESOME_CITIES",
  },
  {
    title: "JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem",
  },

  {
    title: "Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    img_mob: "/PostCarousel/video_mob/post-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tel_Aviv",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    // "isVid": false,
    forVidPage: true,
    ctg: "general",
    id: "Tel_Aviv",
  },

  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    img_mob: "/PostCarousel/video_mob/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "eilat-negev",
    id: "EILAT1",
  },

  {
    title: "Amazing Nightlife",
    sml_desc: "",
    // "sml_desc": "Amazing Nightlife",
    desc: "",
    // "desc": "It’s a never-ending party<br> in the nonstop city!",
    img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    img_mob: "/PostCarousel/video_mob/amazing-nightlife.jpg",
    side_img: "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Amazing_Nightlife",
  },

  {
    title: "Cool Jerusalem",
    // "sml_desc": "A city beyond expectations",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/38.jpg",
    img_mob: "/PostCarousel/video_mob/cool-jerusalem.jpg",
    side_img: "/PostCarousel/38.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cool_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    id: "Cool_Jerusalem",
  },
  {
    title: "MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    img_mob: "/PostCarousel/video_mob/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    // "isVid": false,
    forVidPage: true,
    ctg: "general",
    id: "Masada",
  },
  {
    title: "THE MAGICAL DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    img_mob: "/PostCarousel/video_mob/magical-deadsea.jpg",
    side_img: "/PostCarousel/DeadSea/magical-deadsea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Magical_Deadsea",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Magical_Deadsea",
  },

  {
    title: "Market Madness",
    // "sml_desc": "Market Madness",
    sml_desc: "",
    // "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
    desc: "",
    img: "Videos/market-madness.jpg",
    img_mob: "/Videos/video_mob/market-madness.jpg",
    img_mob: "/Videos/video_mob/market-madness.jpg",
    side_img: "Videos/sidebar/market-madness.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Market_Madness",
    vidId: "2CSCe2WC7Ns",
    ctg: "jerusalem",
    isVid: true,
    id: "Market_Madness",
  },

  // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"
  {
    title: "Looking for a crazy nightlife?",
    // "sml_desc": " Book your trip to Tel Aviv!",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/crazy-night.jpg",
    img_mob: "/Videos/video_mob/crazy-night.jpg",
    side_img: "Videos/sidebar/crazy-night.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    vidId: "ogEN7aRT0SM",
    ctg: "telaviv",
    isVid: true,
    id: "Amazing_Nightlife",
  },
  // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"

  {
    title: "JERUSALEM",
    // "sml_desc": "THE HEART OF THE WORLD",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/heart-of-the-world.jpg",
    img_mob: "/Videos/video_mob/heart-of-the-world.jpg",
    side_img: "Videos/sidebar/heart-of-the-world.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Heart_Of_The_World",
    vidId: "nLKWDp5uA-U",
    ctg: "jerusalem",
    isVid: true,
    id: "Heart_Of_The_World",
  },
  {
    title: "THE DEAD SEA NATURAL SPA",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    img_mob: "/PostCarousel/video_mob/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Natural_Spa",
  },
  {
    title: "Tel-Aviv Highlights",
    // "sml_desc": "Top 5 things to see and\n do in the city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/17.jpg",
    img_mob: "/PostCarousel/video_mob/telaviv-highlights.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=17",
    ctg: "telaviv",
    vidId: "LLOUxE-K_9Y",
    isVid: true,
    // "isVid": false,
    forVidPage: true,
    id: "Tel-Aviv_Highlights",
  },
  {
    title: "First Time in Jerusalem",
    // "sml_desc": "The must list for the first time visitor",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    img_mob: "/PostCarousel/video_mob/first-in-jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=First_Time_In_Jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "First_Time_In_Jerusalem",
  },

  {
    title: "MAMILLA AVENUE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Mamilla_Avenue",
  },
  {
    title: "Joys of Jaffa",
    sml_desc: "",
    // "sml_desc" : "Ancient, Artsy and Fabulous",
    desc: "",
    // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
    img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    img_mob: "/PostCarousel/video_mob/joys-of-jaffa.jpg",
    side_img: "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Joys_Of_Jaffa",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Joys_Of_Jaffa",
  },

  {
    title: "TEL AVIV BY THE SEA",
    // "sml_desc": "Cause life’s a beach in Tel Aviv ",
    sml_desc: "",
    // "desc": "Get ready for some serious fun",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "XDei1Zy_cu4",
    ctg: "telaviv",
    isVid: true,
    id: "TelAviv_By_The_Sea",
  },

  {
    title: "Neve Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic and Unique  ",
    // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "READ MORE",
    vidId: "5jl13Z-38eE",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "telaviv",
    isVid: true,
    id: "Neve_Tzedek",
  },
  {
    title: "MUST EAT IN JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    img_mob: "/PostCarousel/video_mob/must-eat-in-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Must_Eat_In_Jerusalem",
  },

  {
    title: "Shopping Delights",
    // "sml_desc": "From culture to souvenirs",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/5.jpg",
    img_mob: "/PostCarousel/video_mob/shopping-delights.jpg",
    side_img: "/PostCarousel/5.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Shopping_Delights",
    ctg: "jerusalem",
    // "isVid": false,
    isVid: true,
    vidId: "MXtcTm_JXus",
    forVidPage: true,
    id: "Shopping_Delights",
  },
  {
    title: "NATURE'S GLORY",
    // "sml_desc": "THE DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/natures-glory.jpg",
    img_mob: "/PostCarousel/video_mob/natures-glory.jpg",
    side_img: "/PostCarousel/DeadSea/natures-glory.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natures_Glory",
    isVid: true,
    vidId: "M627s8TdaB8",
    // "isVid": false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Natures_Glory",
  },

  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "A huge selection of attractions  <br/> in a stunningly renovated Templar colony",
    // "sml_desc": "A stunning urban oasis",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=Sarona_TelAviv",
    vidId: "AcjsyamDZL8",
    ctg: "telaviv",
    isVid: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "THE GATES OF JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gates.jpg",
    img_mob: "/PostCarousel/video_mob/gates.jpg",
    side_img: "/PostCarousel/Jerusalem/gates.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    isVid: true,
    vidId: "MXtcTm_JXus",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "The_Gates_Of_Jerusalem",
  },

  {
    title: "JERUSALEM MAIN SITES",
    // "sml_desc": "Travel back thousands of years",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    img_mob: "/PostCarousel/video_mob/main-sites-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=9",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Main_Sites",
  },

  {
    title: "Tel Aviv street food",
    // "sml_desc" : "Tel Aviv street food",
    sml_desc: "",
    // "desc" : "A true world-class foodie destination",
    desc: "",
    img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    img_mob: "/PostCarousel/video_mob/streetfood-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tel_Aviv_Street_Food",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Tel_Aviv_Street_Food",
  },

  {
    title: "JERUSALEM FUN",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem-fun.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Fun",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Fun",
  },
  {
    title: "EILAT’S CALLING",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-calling.jpg",
    img_mob: "/PostCarousel/video_mob/eilat-calling.jpg",
    side_img: "/PostCarousel/eilat-calling.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Calling",
    css_class: "unic-post-eilat-calling",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Calling",
  },
  {
    title: "Cycle Tel Aviv",
    // "desc": "Get on your bicycle -<br> explore the city in style",
    sml_desc: "",
    desc: "",
    img: "PostCarousel/39.jpg",
    img_mob: "/PostCarousel/video_mob/cycle-telaviv.jpg",
    side_img: "PostCarousel/39.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "telaviv",
    isVid: true,
    vidId: "88OV6xU0vPI",
    // "isVid": false,
    forVidPage: true,
    id: "Cycle_TelAviv",
  },
  {
    title: "Jerusalem ‘Musts’",
    // "sml_desc": "5 things to do in the stunning city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem-musts.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_Musts",
  },

  {
    title: "ULTIMATE BEACH FUN",
    sml_desc: "",
    // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    desc: "",
    img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    img_mob: "/PostCarousel/video_mob/ultimate-beaches.jpg",
    side_img: "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=24",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: true,
    id: "Ultimate_Beach_Fun",
    ctg: "telaviv",
    showOnHome: false,
  },

  {
    title: "Modern and Vibrant",
    // "sml_desc": "So much to see in Jerusalem’s",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/19.jpg",
    img_mob: "/PostCarousel/video_mob/modern-vibrant.jpg",
    side_img: "/PostCarousel/19.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Modern_And_Vibrant",
    isVid: true,
    vidId: "MXtcTm_JXus",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Modern_And_Vibrant",
  },
  {
    title: "WHITE CITY SPLENDOR",
    sml_desc: "",
    desc: "",
    img: "thingsToDo/6.jpg",
    side_img: "thingsToDo/sidebar/6.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: true,
    // "isVid": false,
    id: "White_City_Splendor",
    showOnHome: false,
    ctg: "telaviv",
  },
  {
    title: "NATURAL PHENOMENA",
    // "sml_desc": "THE DEAD SEA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    img_mob: "/PostCarousel/video_mob/natural-phenomena.jpg",
    side_img: "/PostCarousel/DeadSea/natural-phenomena.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Phenomena",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    ctg: "deadsea",
    id: "Natural_Phenomena",
  },
  {
    title: "Jerusalem after dark fun",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    img_mob: "/PostCarousel/video_mob/after-dark-fun.jpg",
    side_img: "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    // "isVid": false,
    forVidPage: true,
    ctg: "jerusalem",
    id: "Jerusalem_After_Dark_Fun",
  },

  //Hadar asked to hide the video in this post on 18.01.2021
  // {
  //    "title" : "Non Stop Culture",
  //     // "sml_desc": "Non Stop Culture",
  //     "sml_desc" : "",
  //     // "desc": "Tel Aviv’s fascinating cultural scene",
  //      "desc" : "",
  //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "img_mob":"/PostCarousel/video_mob/culture-telaviv.jpg",
  //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=Non_Stop_Culture",
  //     "isVid": false,
  //     "vidId":"MXtcTm_JXus",
  //     // "isVid": false,
  //     "ctg": "telaviv",
  //     "forVidPage": true,
  //     "id": "Non_Stop_Culture"
  // },
  // End Hadar asked to hide the video in this post on 18.01.2021

  // {
  //     "title": "ALL SENSORY MARKETS",
  //     "sml_desc": "",
  //     "img": "thingsToDo/8.jpg",
  //     "side_img": "thingsToDo/sidebar/8.jpg",
  //     "read_more": "READ MORE",
  //     "link": "/Posts/index.php?post=20",
  //     "css_class": "unic_video-post-1",
  //     "vidId": "88OV6xU0vPI",
  //     "isVid": true,
  //     // "isVid": false,
  //     "id": "All_Sensory_Markets",
  //     "showOnHome": false,
  //     "ctg": "culinary"

  // },

  {
    title: "Port Pleasures ",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    img_mob: "/PostCarousel/video_mob/post-pleasures.jpg",
    side_img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Port_Pleasures",
  },

  {
    title: "Nonstop Excitement",
    // "sml_desc": "unforgettable Tel Aviv ",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    img_mob: "/PostCarousel/video_mob/nonstop-excitement2.jpg",
    side_img: "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nonstop_Excitement",
    ctg: "telaviv",
    isVid: true,
    vidId: "88OV6xU0vPI",
    // "isVid": false,
    forVidPage: true,
    id: "Nonstop_Excitement",
  },

  // Eilat Posts
  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    img_mob: "/PostCarousel/video_mob/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "EILAT1",
  },
  {
    title: "Party Capital",
    // "sml_desc": "Epic Nights in the non stop city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/42.jpg",
    img_mob: "/PostCarousel/video_mob/party-capital.jpg",
    side_img: "/PostCarousel/42.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=42",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // "isVid": false,
    forVidPage: true,
    ctg: "telaviv",
    id: "Party_Capital",
  },
  {
    title: "Welcome to Eilat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/welcome-to-eilat.jpg",
    img_mob: "/PostCarousel/video_mob/welcome-to-eilat.jpg",
    side_img: "/PostCarousel/welcome-to-eilat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Welcome_To_Eilat",
    css_class: "unic-post-welcome-to-eilat",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Welcome_To_Eilat",
  },

  {
    title: "Negev",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev.jpg",
    img_mob: "/PostCarousel/video_mob/negev1.jpg",
    side_img: "/PostCarousel/negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev1",
    css_class: "unic-post-negev",
    isVid: true,
    vidId: "yXzhH92kREg",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Negev1",
  },

  {
    title: "EILAT ULTIMATE BEACHSIDE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    img_mob: "/PostCarousel/video_mob/eilat-ultimate-beachside.jpg",
    side_img: "/PostCarousel/eilat-ultimate-beachside.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Ultimate_Beachside",
    css_class: "unic-post-eilat-ultimate-beachside",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Ultimate_Beachside",
  },
  {
    title: "Galilee",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee.jpg",
    img_mob: "/PostCarousel/video_mob/galilee.jpg",
    side_img: "/PostCarousel/galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee",
    css_class: "unic-post-galilee",
    isVid: true,
    vidId: "5Ep3GgxELag",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee",
  },
  {
    title: "Epic Masada",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    img_mob: "/PostCarousel/video_mob/epic-masada.jpg",
    side_img: "/PostCarousel/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Epic_Masada",
  },
  {
    title: "The Dead Sea",
    // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/next-level.jpg",
    img_mob: "/PostCarousel/video_mob/next-level.jpg",
    side_img: "/PostCarousel/DeadSea/next-level.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Next_Level_DS",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    ctg: "general",
    id: "Next_Level_DS",
  },
  {
    title: "Caesarea",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    img_mob: "/PostCarousel/video_mob/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea",
    css_class: "unic-post-caesarea",
    isVid: true,
    vidId: "eLZ433_S6HI",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Caesarea",
  },
  {
    title: "NEGEV CHARMS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-charms.jpg",
    img_mob: "/PostCarousel/video_mob/negev-charms.jpg",
    side_img: "/PostCarousel/negev-charms.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Charms",
    css_class: "unic-post-negev-charms",
    isVid: true,
    vidId: "3UddwPEzDXo",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Negev_Charms",
  },
  {
    title: "Acre",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    img_mob: "/PostCarousel/video_mob/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: true,
    vidId: "KlXXyToCmCM",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  {
    title: "THE INCENSE ROUTE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-incense-route.jpg",
    img_mob: "/PostCarousel/video_mob/the-incense-route.jpg",
    side_img: "/PostCarousel/the-incense-route.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Incense_Route",
    css_class: "unic-post-the-incense-route",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "The_Incense_Route",
  },
  {
    title: "Haifa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    img_mob: "/PostCarousel/video_mob/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: true,
    vidId: "3ahATaKkhBk",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Haifa",
  },

  {
    title: "Sensational Beaches",
    // "sml_desc": "Come chill by the sunny beaches",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    side_img: "/PostCarousel/TelAviv/sensational-beaches2.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=14",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "telaviv",
    //"id": 14
    id: "Sensational_Beaches",
  },
  {
    title: "LOCATION AND APPROACH",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/location-and-approach.jpg",
    img_mob: "/PostCarousel/video_mob/location-and-approach.jpg",
    side_img: "/PostCarousel/location-and-approach.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Location_And_Approach",
    css_class: "unic-post-location-and-approach",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Location_And_Approach",
  },
  {
    title: "Timna Treasures",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/timna-treasures.jpg",
    img_mob: "/PostCarousel/video_mob/timna-treasures.jpg",
    side_img: "/PostCarousel/timna-treasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Timna_Treasures",
    css_class: "unic-post-timna-treasures",
    isVid: true,
    vidId: "i_4QKtXIeto",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Timna_Treasures",
  },

  {
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    img_mob: "/PostCarousel/video_mob/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: true,
    vidId: "i3_ihL51bHo",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Safed",
  },
  {
    title: "EILAT’S DOLPHIN REEF",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat-doolphin-reef.jpg",
    img_mob: "/PostCarousel/video_mob/eilat-doolphin-reef.jpg",
    side_img: "/PostCarousel/eilat-doolphin-reef.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Eilat_Doolphin_Reef",
    css_class: "unic-post-eilat-doolphin-reef",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Eilat_Doolphin_Reef",
  },
  {
    title: "THE STUNNING BAHA’I GARDENS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/bahai-gardens.jpg",
    img_mob: "/PostCarousel/video_mob/bahai-gardens.jpg",
    side_img: "/PostCarousel/bahai-gardens.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Bahai_Gardens",
    css_class: "unic-post-bahai-gardens",
    isVid: true,
    vidId: "JV_AmfRULOo",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "The_Bahai_Gardens",
  },
  {
    title: "ACTION FUN IN THE ISRAELI DESERT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/action-fun-in-the-desert.jpg",
    img_mob: "/PostCarousel/video_mob/action-fun-in-the-desert.jpg",
    side_img: "/PostCarousel/action-fun-in-the-desert.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Action_Fun_In_The_Desert",
    css_class: "unic-post-action-fun-in-the-desert",
    isVid: true,
    vidId: "yXzhH92kREg",
    // "isVid": false,
    forVidPage: true,
    ctg: "eilat-negev",
    id: "Action_Fun_In_The_Desert",
  },
  {
    title: "The Sea of Galilee (Kinneret )",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/sea-of-galilee.jpg",
    img_mob: "/PostCarousel/video_mob/sea-of-galilee.jpg",
    side_img: "/PostCarousel/sea-of-galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Sea_Of_Galilee",
    css_class: "unic-post-sea-of-galilee",
    isVid: true,
    vidId: "haG-t3wwuMc",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "The_Sea_Of_Galilee",
  },
  {
    title: "Rosh Pina",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/rosh-pina.jpg",
    img_mob: "/PostCarousel/video_mob/rosh-pina.jpg",
    side_img: "/PostCarousel/rosh-pina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Rosh_Pina",
    css_class: "unic-post-rosh-pina",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Rosh_Pina",
  },
  {
    title: "GALILEE ACTION",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee-action.jpg",
    img_mob: "/PostCarousel/video_mob/galilee-action.jpg",
    side_img: "/PostCarousel/galilee-action.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee_Action",
    css_class: "unic-post-galilee-action",
    isVid: true,
    vidId: "5Ep3GgxELag",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Galilee_Action",
  },
  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    img_mob: "/PostCarousel/video_mob/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Nazareth",
  },

  {
    title: "Birdtastic Hula Lake",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/birdtastic-hula-lake.jpg",
    img_mob: "/PostCarousel/video_mob/birdtastic-hula-lake.jpg",
    side_img: "/PostCarousel/birdtastic-hula-lake.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Birdtastic_Hula_Lake",
    css_class: "unic-post-birdtastic-hula-lake",
    isVid: true,
    vidId: "ImobrsxsKl8",
    // "isVid": false,
    forVidPage: true,
    ctg: "north",
    id: "Birdtastic_Hula_Lake",
  },

  // These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
  {
    title: "THE DEAD SEA NATURAL SPA",
    sml_desc: "",
    // "sml_desc": "THE DEAD SEA",
    desc: "",
    img: "/PostCarousel/DeadSea/natural-spa.jpg",
    img_mob: "/PostCarousel/video_mob/natural-spa.jpg",
    side_img: "/PostCarousel/DeadSea/natural-spa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Natural_Spa",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "deadsea",
    id: "Natural_Spa",
  },
  {
    title: "NEGEV CHARMS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev-charms.jpg",
    img_mob: "/PostCarousel/video_mob/negev-charms.jpg",
    side_img: "/PostCarousel/negev-charms.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev_Charms",
    css_class: "unic-post-negev-charms",
    isVid: true,
    vidId: "3UddwPEzDXo",
    // "isVid": false,
    forVidPage: true,
    isDouble: true,
    ctg: "eilat-negev",
    id: "Negev_Charms",
  },

  // These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
];

export const TouristInfoPosts = [
  {
    title: "What To Pack",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/what-to-pack.jpg",
    side_img: "/PostCarousel/what-to-pack.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-what-to-pack",
    isVid: false,
    ctg: "TouristInfo",
    id: "What_To_Pack",
  },
  // This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  //  {
  //  "title":"Immigration Customs",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/immigration-customs.jpg",
  //  "side_img":"/PostCarousel/immigration-customs.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=20",
  //  "css_class":"unic-post-immigration-customs",
  //  "isVid" : false,
  //  "ctg"   : 'TouristInfo',
  //   "id"    : 'Immigration_Customs'
  // },
  // END This post had moved to the Passport post/ ASked by HADAR 18.05.2020

  {
    title: "Weather",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/weather.jpg",
    side_img: "/PostCarousel/weather.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-weather",
    isVid: false,
    ctg: "TouristInfo",
    id: "Weather",
  },
  {
    title: "Transportation",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/transportation.jpg",
    side_img: "/PostCarousel/transportation.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-transportation",
    isVid: false,
    ctg: "TouristInfo",
    id: "Transportation",
  },
  {
    title: "Frequently Asked Questions",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/faq.jpg",
    side_img: "/PostCarousel/faq.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-faq",
    isVid: false,
    ctg: "TouristInfo",
    id: "Frequently_Asked_Questions",
  },

  {
    title: "Israeli Currency",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/israeli-currency.jpg",
    side_img: "/PostCarousel/israeli-currency.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-israeli-currency",
    isVid: false,
    ctg: "TouristInfo",
    id: "Israeli_Currency",
  },
  {
    title: "Electrical Appliances",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/electrical-appliances.jpg",
    side_img: "/PostCarousel/electrical-appliances.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-electrical-appliances",
    isVid: false,
    ctg: "TouristInfo",
    id: "Electrical_Appliances",
  },
  {
    title: "Passports Visa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Passports-visa.jpg",
    side_img: "/PostCarousel/Passports-visa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Passports_Visa",
  },
  {
    title: "A Destination for All",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    side_img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Destination_For_All",
  },
];

export const Reminders = [
  // Tel Aviv
  {
    quote: "One of the world's 25 best cities for foodies",
    site: "Business Insider",
    img: "/References/1.jpg",
    ctg: "Tel Aviv",
  },

  // Jerusalem
  {
    quote: "TripAdvisor Traveler's Choice Award 2015",
    site: "TripAdvisor",
    img: "/References/9.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's leading party cities",
    site: "Telegraph",
    img: "/References/2.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the cities with most beautiful people",
    site: "Conde Nast",
    img: "/References/3.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the 20 must visit destinations in the world  TNS",
    site: "The National Student",
    img: "/References/10.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the best beach party spots on the planet",
    site: "USA Today",
    img: "/References/4.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top 10 beach cities",
    site: "National Geographic",
    img: "/References/5.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "3rd Of 6 Top world’s holiest sites",
    site: "National Geographic",
    img: "/References/11.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's top ten cities",
    site: "Lonely Planet",
    img: "/References/6.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top ten hedonistic city breaks ",
    site: "Lonely Planet",
    img: "/References/7.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote:
      "I just thought it was magical… It instantly turned into my favorite trip.",
    site: "TripAdvisor",
    img: "/References/12.jpg",
    ctg: "Jerusalem",
    job: "CEO, Stephen Kaufer about Jerusalem",
    cssClass: "make-it-smller",
  },

  {
    quote: "The World’s New Dining Hotspot",
    site: "Bloomberg.com",
    img: "/References/8.jpg",
    ctg: "Tel Aviv",
  },
];

export const agentsArr = [
  {
    title: "Catholic 7 Day Itinerary",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/catholic7dayitinerary.jpg",
    side_img: "/PostCarousel/Itineraries/catholic7dayitinerary.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Catholic-7_Day_Itinerary",
  },
  {
    title: "Youth Itinerary - 7 Day Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/youthitinerary7daytour.jpg",
    side_img: "/PostCarousel/Itineraries/youthitinerary7daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Youth_Itinerary_7_Day_Tour",
  },
  {
    title: "First Timers - 7 Day Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/firsttimers7daytour.jpg",
    side_img: "/PostCarousel/Itineraries/firsttimers7daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "First_Timers_7_Day_Tour",
  },
  {
    title: "Christian Interest Itinerary - 10 Days Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/christianinterestitineraries10daystour.jpg",
    side_img:
      "/PostCarousel/Itineraries/christianinterestitineraries10daystour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Christian_Interest_Itinerary_10_Days_Tour",
  },
  {
    title: "A Christian Adventure Itinerary",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    side_img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Eilat_To_Jerusalem_In_10_Days",
  },
  {
    title: "A Christian Adventure Itinerary",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    side_img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "A_Christian_Adventure_Itinerary",
  },
  {
    title: "Evangelical Christian Itineraries - 10 Day Tour",
    sml_desc: "",
    desc: "",
    img:
      "/PostCarousel/Itineraries/evangelicalchristianitineraries10daytour.jpg",
    side_img:
      "/PostCarousel/Itineraries/evangelicalchristianitineraries10daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Evangelical_Christian_Itineraries_10_Day_Tour",
  },
  {
    title: "Catholic Interest Itineraries - 10 Days Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/catholicinterestitineraries10daystour.jpg",
    side_img:
      "/PostCarousel/Itineraries/catholicinterestitineraries10daystour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Catholic_Interest_Itineraries_10_Days_Tour",
  },
  {
    title: "Women in the Old and New Testament",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/womenintheoldandnewtestament.jpg",
    side_img: "/PostCarousel/Itineraries/womenintheoldandnewtestament.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Women_In_The_Old_And_New_Testament",
  },
  {
    title: "JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Jerusalem",
  },
  {
    title: "Tel Aviv",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    side_img: "/PostCarousel/TelAviv/post-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Tel_Aviv",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Tel_Aviv",
  },
  {
    title: "The Dead Sea",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/next-level.jpg",
    side_img: "/PostCarousel/DeadSea/next-level.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Next_Level_DS",
    isVid: true,
    vidId: "8p4qfkneH1c",
    // "isVid": false,
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Next_Level_DS",
  },
  {
    title: "MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/DeadSea/masada.jpg",
    side_img: "/PostCarousel/DeadSea/masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Masada",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    forVidPage: true,
    isDouble: false,
    ctg: "general",
    id: "Masada",
  },
  {
    title: "The Sea of Galilee (Kinneret )",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/sea-of-galilee.jpg",
    side_img: "/PostCarousel/sea-of-galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Sea_Of_Galilee",
    css_class: "unic-post-sea-of-galilee",
    isVid: true,
    isDouble: false,
    vidId: "haG-t3wwuMc",
    forVidPage: true,
    ctg: "general",
    id: "The_Sea_Of_Galilee",
  },
  {
    title: "Negev",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/negev.jpg",
    img_mob: "/PostCarousel/video_mob/negev1.jpg",
    side_img: "/PostCarousel/negev.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Negev1",
    css_class: "unic-post-negev",
    isVid: true,
    vidId: "yXzhH92kREg",
    forVidPage: true,
    ctg: "general",
    id: "Negev1",
  },
  {
    title: "EILAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/eilat1.jpg",
    img_mob: "/PostCarousel/video_mob/eilat1.jpg",
    side_img: "/PostCarousel/eilat1.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=EILAT1",
    css_class: "unic-post-EILAT1",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    forVidPage: true,
    ctg: "general",
    id: "EILAT1",
  },
  {
    title: "Galilee",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee.jpg",
    img_mob: "/PostCarousel/video_mob/galilee.jpg",
    side_img: "/PostCarousel/galilee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Galilee",
    css_class: "unic-post-galilee",
    isVid: true,
    vidId: "5Ep3GgxELag",
    forVidPage: true,
    ctg: "general",
    id: "Galilee",
  },
  {
    title: "Nazareth",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/nazareth.jpg",
    img_mob: "/PostCarousel/video_mob/nazareth.jpg",
    side_img: "/PostCarousel/nazareth.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Nazareth",
    css_class: "unic-post-nazareth",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    forVidPage: true,
    ctg: "general",
    id: "Nazareth",
  },
  {
    title: "Haifa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/haifa.jpg",
    img_mob: "/PostCarousel/video_mob/haifa.jpg",
    side_img: "/PostCarousel/haifa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Haifa",
    css_class: "unic-post-haifa",
    isVid: true,
    vidId: "3ahATaKkhBk",
    forVidPage: true,
    ctg: "general",
    id: "Haifa",
  },
  {
    title: "THE STUNNING BAHA’I GARDENS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/bahai-gardens.jpg",
    img_mob: "/PostCarousel/video_mob/bahai-gardens.jpg",
    side_img: "/PostCarousel/bahai-gardens.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Bahai_Gardens",
    css_class: "unic-post-bahai-gardens",
    isVid: true,
    vidId: "JV_AmfRULOo",
    forVidPage: true,
    ctg: "general",
    id: "The_Bahai_Gardens",
  },
  {
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    img_mob: "/PostCarousel/video_mob/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: true,
    vidId: "i3_ihL51bHo",
    forVidPage: true,
    ctg: "general",
    id: "Safed",
  },
  {
    title: "Rosh Pina",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/rosh-pina.jpg",
    side_img: "/PostCarousel/rosh-pina.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Rosh_Pina",
    css_class: "unic-post-rosh-pina",
    isVid: true,
    isDouble: false,
    vidId: "_qKbHL5-qrQ",
    forVidPage: true,
    ctg: "general",
    id: "Rosh_Pina",
  },
  {
    title: "Caesarea",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/caesarea.jpg",
    img_mob: "/PostCarousel/video_mob/caesarea.jpg",
    side_img: "/PostCarousel/caesarea.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Caesarea",
    css_class: "unic-post-caesarea",
    isVid: true,
    vidId: "eLZ433_S6HI",
    forVidPage: true,
    ctg: "general",
    id: "Caesarea",
  },
  {
    title: "Acre",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/acre.jpg",
    img_mob: "/PostCarousel/video_mob/acre.jpg",
    side_img: "/PostCarousel/acre.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Acre",
    css_class: "unic-post-acre",
    isVid: true,
    vidId: "KlXXyToCmCM",
    forVidPage: true,
    ctg: "north",
    id: "Acre",
  },
  {
    title: "Bet She’an",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/bet-shean.jpg",
    side_img: "/PostCarousel/bet-shean.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Bet_Shean",
    css_class: "unic-post-bet-shean",
    isVid: false,
    isDouble: false,
    ctg: "general",
    id: "Bet_Shean",
  },
  {
    title: "NATIONAL PARKS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/national-parks.jpg",
    side_img: "/PostCarousel/national-parks.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=National_Parks",
    css_class: "unic-post-national-parks",
    isVid: false,
    isDouble: false,
    ctg: "general",
    id: "National_Parks",
  },
  {
    title: "Israel National Trail",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/the-israel-national-trail.jpg",
    side_img: "/PostCarousel/the-israel-national-trail.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Israel_National_Trail",
    css_class: "unic-post-the-israel-national-trail",
    isVid: false,
    isDouble: false,
    ctg: "general",
    id: "The_Israel_National_Trail",
  },
  {
    title: "Sarona Tel Aviv",
    desc: "",
    // "desc": "A huge selection of attractions  <br/> in a stunningly renovated Templar colony",
    // "sml_desc": "A stunning urban oasis",
    sml_desc: "",
    img: "Videos/d.jpg",
    img_mob: "/Videos/video_mob/d.jpg",
    side_img: "Videos/sidebar/d.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=Sarona_TelAviv",
    vidId: "AcjsyamDZL8",
    ctg: "general",
    isVid: true,
    id: "Sarona_TelAviv",
  },
  {
    title: "MAMILLA AVENUE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/mamila-avenue.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Mamilla_Avenue",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    // "isVid": false,
    forVidPage: true,
    ctg: "general",
    id: "Mamilla_Avenue",
  },
  {
    title: "Neve Tzedek",
    sml_desc: "",
    // "sml_desc" : "Chic and Unique  ",
    // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
    desc: "",
    img: "Videos/j.jpg",
    img_mob: "/Videos/video_mob/j.jpg",
    side_img: "Videos/sidebar/j.jpg",
    read_more: "READ MORE",
    vidId: "5jl13Z-38eE",
    link: "/Posts/index.php?postType=video&post=7",
    css_class: "unic_video-post-13",
    ctg: "general",
    isVid: true,
    id: "Neve_Tzedek",
  },
  {
    title: "TEL AVIV BY THE SEA",
    // "sml_desc": "Cause life’s a beach in Tel Aviv ",
    sml_desc: "",
    // "desc": "Get ready for some serious fun",
    desc: "",
    img: "Videos/a.jpg",
    img_mob: "/Videos/video_mob/a.jpg",
    side_img: "Videos/sidebar/a.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=3",
    css_class: "unic_video-post-4",
    vidId: "XDei1Zy_cu4",
    ctg: "general",
    isVid: true,
    id: "TelAviv_By_The_Sea",
  },
  {
    title: "Boutique Hospitality",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    side_img: "/PostCarousel/TelAviv/boutique-hospitality.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Boutique_Hospitality",
    isVid: false,
    isDouble: true,
    ctg: "general",
    id: "Boutique_Hospitality",
  },
  {
    title: "Tel-Aviv Highlights",
    // "sml_desc": "Top 5 things to see and\n do in the city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/17.jpg",
    img_mob: "/PostCarousel/video_mob/telaviv-highlights.jpg",
    side_img: "/PostCarousel/17.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=17",
    ctg: "general",
    vidId: "LLOUxE-K_9Y",
    isVid: true,
    // "isVid": false,
    forVidPage: true,
    id: "Tel-Aviv_Highlights",
  },
  {
    title: "Jerusalem ‘Musts’",
    // "sml_desc": "5 things to do in the stunning city",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/18.jpg",
    img_mob: "/PostCarousel/video_mob/jerusalem-musts.jpg",
    side_img: "/PostCarousel/18.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Musts",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    // "isVid": false,
    forVidPage: true,
    ctg: "general",
    id: "Jerusalem_Musts",
  },
  {
    title: "Looking for a crazy nightlife?",
    // "sml_desc": " Book your trip to Tel Aviv!",
    sml_desc: "",
    // "desc": "",
    desc: "",
    img: "Videos/crazy-night.jpg",
    img_mob: "/Videos/video_mob/crazy-night.jpg",
    side_img: "Videos/sidebar/crazy-night.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Amazing_Nightlife",
    vidId: "ogEN7aRT0SM",
    ctg: "general",
    isVid: true,
    id: "Amazing_Nightlife",
  },
  {
    title: "Port Pleasures ",
    // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    sml_desc: "",
    // "desc": "Tel Aviv’s fascinating cultural scene",
    desc: "",
    img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    img_mob: "/PostCarousel/video_mob/post-pleasures.jpg",
    side_img: "/PostCarousel/TelAviv/post-pleasures.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Port_Pleasures",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    forVidPage: true,
    ctg: "general",
    id: "Port_Pleasures",
  },
  {
    title: "THE GATES OF JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gates.jpg",
    img_mob: "/PostCarousel/video_mob/gates.jpg",
    side_img: "/PostCarousel/Jerusalem/gates.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=The_Gates_Of_Jerusalem",
    isVid: true,
    vidId: "MXtcTm_JXus",
    forVidPage: true,
    isDouble: false,
    ctg: "jewish",
    id: "The_Gates_Of_Jerusalem",
  },
  {
    title: "Epic Masada",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/epic-masada.jpg",
    side_img: "/PostCarousel/video_mob/epic-masada.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Epic_Masada",
    css_class: "unic-post-epic-masada",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    isDouble: false,
    ctg: "jewish",
    id: "Epic_Masada",
  },
  {
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/safed.jpg",
    side_img: "/PostCarousel/safed.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Safed",
    css_class: "unic-post-safed",
    isVid: true,
    isDouble: false,
    vidId: "i3_ihL51bHo",
    forVidPage: true,
    ctg: "jewish",
    id: "Safed",
  },
  {
    title: "Sectrets of jewish Jerusalem",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/secrets-jer.jpg",
    side_img: "/PostCarousel/Jerusalem/secrets-jer.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
    isVid: false,
    isDouble: false,
    ctg: "jewish",
    id: "Sectrets_Of_Jewish_Jerusalem",
  },
  {
    title: "WESTERN WALL WONDERS",
    sml_desc: "",
    img: "thingsToDo/4.jpg",
    side_img: "thingsToDo/sidebar/4.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Western_Wall_Wonders",
    css_class: "unic_video-post-Western_Wall_Wonders",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: "Western_Wall_Wonders",
    ctg: "jewish",
    showOnHome: false,
  },
  {
    title: "UNFORGETTABLE YAD VASHEM",
    sml_desc: "",
    img: "thingsToDo/10.jpg",
    side_img: "thingsToDo/sidebar/10.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic_video-post-1",
    vidId: "88OV6xU0vPI",
    isVid: false,
    isDouble: false,
    id: 31,
    showOnHome: false,
    ctg: "jewish",
  },

  {
    title: "Jerusalem’s Old City",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    side_img: "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jerusalem_Old_City",
    isVid: false,
    isDouble: false,
    ctg: "jewish",
    id: "Jerusalem_Old_City",
  },
  {
    title: "PURCHASES IN ISRAEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/unique.jpg",
    side_img: "/PostCarousel/Jerusalem/unique.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Purchases_In_Israel",
    isVid: false,
    isDouble: false,
    ctg: "jewish",
    id: "Purchases_In_Israel",
  },
  {
    title: "Haifa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/haifa.jpg",
    side_img: "/PostCarousel/CoastalPlain/haifa.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "3ahATaKkhBk",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Haifa",
  },
  {
    title: "AKKO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/akko.jpg",
    side_img: "/PostCarousel/CoastalPlain/akko.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "KlXXyToCmCM",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Akko",
  },
  {
    title: "CAESAREA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/caesarea.jpg",
    side_img: "/PostCarousel/CoastalPlain/caesarea.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "eLZ433_S6HI",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Caesarea",
  },
  {
    title: "JAFFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/jaffa.jpg",
    side_img: "/PostCarousel/CoastalPlain/jaffa.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "tgF0zMUYY2g",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Jaffa",
  },
  {
    title: "CAESAREA PHILIPPI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/caesareaphilippi.jpg",
    side_img: "/PostCarousel/galilee/caesareaphilippi.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "5Ep3GgxELag",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Caesarea_Philippi",
  },
  {
    title: "NAZARETH",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/nazareth.jpg",
    side_img: "/PostCarousel/galilee/nazareth.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Nazareth",
  },
  {
    title: "SEA OF GALILEE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/seaofgalilee.jpg",
    side_img: "/PostCarousel/galilee/seaofgalilee.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "haG-t3wwuMc",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Sea_Of_Galilee",
  },
  {
    title: "MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/masada.jpg",
    side_img: "/PostCarousel/valleydesert/masada.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Masada",
  },
  {
    title: "MOUNT CARMEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/mountcarmel.jpg",
    side_img: "/PostCarousel/CoastalPlain/mountcarmel.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Mount_Carmel",
  },
  {
    title: "MEGIDDO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/megiddo.jpg",
    side_img: "/PostCarousel/galilee/megiddo.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Megiddo",
  },
  {
    title: "CANA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/cana.jpg",
    side_img: "/PostCarousel/galilee/cana.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Cana",
  },
  {
    title: "CAPERNAUM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/capernaum.jpg",
    side_img: "/PostCarousel/galilee/capernaum.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Caper_Naum",
  },
  {
    title: "MAGDALA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/magdala.jpg",
    side_img: "/PostCarousel/galilee/magdala.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Magdala",
  },
  {
    title: "MOUNT OF BEATITUDES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/mountofbeatitudes.jpg",
    side_img: "/PostCarousel/galilee/mountofbeatitudes.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Mount_Of_Beatitudes",
  },
  {
    title: "MOUNT TABOR",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/mounttabor.jpg",
    side_img: "/PostCarousel/galilee/mounttabor.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Mount_Tabor",
  },
  {
    title: "JESUS BOAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/jesusboat.jpg",
    side_img: "/PostCarousel/galilee/jesusboat.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Jesus_Boat",
  },
  {
    title: "TIBERIAS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/tiberias.jpg",
    side_img: "/PostCarousel/galilee/tiberias.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Tiberias",
  },
  {
    title: "YARDENIT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/yardenit.jpg",
    side_img: "/PostCarousel/galilee/yardenit.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Yardenit",
  },
  {
    title: "TABGHA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/tabgha.jpg",
    side_img: "/PostCarousel/galilee/tabgha.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Tabgha",
  },
  {
    title: "THE GOSPEL TRAIL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/thegospeltrail.jpg",
    side_img: "/PostCarousel/galilee/thegospeltrail.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "THE_GOSPEL_TRAIL",
  },
  {
    title: "ZIPPORI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/zippori.jpg",
    side_img: "/PostCarousel/galilee/zippori.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Zippori",
  },
  {
    title: "KURSI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/kursi.jpg",
    side_img: "/PostCarousel/galilee/kursi.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Kursi",
  },
  {
    title: "Mount Zion",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/churchofthedormitiondavidstombupperroom.jpg",
    side_img:
      "/PostCarousel/Jerusalem/churchofthedormitiondavidstombupperroom.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Mount_Zion_Church_of_the_Dormition_Davids_Tomb_Upper_Room",
  },
  {
    title: "CHURCH OF THE HOLY SEPULCHRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/churchoftheholysepulchre.jpg",
    side_img: "/PostCarousel/Jerusalem/churchoftheholysepulchre.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Church_Of_The_Holy_Sepulchre",
  },
  {
    title: "DAVIDSON CENTER",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/davidsoncenter.jpg",
    side_img: "/PostCarousel/Jerusalem/davidsoncenter.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Davidson_Center",
  },
  {
    title: "WESTERN WALL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/westernwall.jpg",
    side_img: "/PostCarousel/Jerusalem/westernwall.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Western_Wall",
  },
  {
    title: "CITY OF DAVID",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/cityofdavid.jpg",
    side_img: "/PostCarousel/Jerusalem/cityofdavid.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "City_Of_David",
  },
  {
    title: "POOL OF SILOAM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/poolofsiloam.jpg",
    side_img: "/PostCarousel/Jerusalem/.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Pool_Of_Siloam",
  },
  {
    title: "ZEDEKIAH’S CAVE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/zedekiahscave.jpg",
    side_img: "/PostCarousel/Jerusalem/zedekiahscave.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Zedekiahs_Cave",
  },
  {
    title: "MOUNT OF OLIVES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/mountofolives.jpg",
    side_img: "/PostCarousel/Jerusalem/mountofolives.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Mount_Of_Olives",
  },
  {
    title: "GARDEN OF GETHSEMANE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gardenofgethsemane.jpg",
    side_img: "/PostCarousel/Jerusalem/gardenofgethsemane.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Garden_Of_Gethsemane",
  },
  {
    title: "VIA DOLOROSA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/viadolorosa.jpg",
    side_img: "/PostCarousel/Jerusalem/viadolorosa.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Via_Dolorosa",
  },
  {
    title: "GATES OF JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gatesofjerusalem.jpg",
    side_img: "/PostCarousel/Jerusalem/gatesofjerusalem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Gates_Of_Jerusalem",
  },
  {
    title: "GARDEN TOMB",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/gardentomb.jpg",
    side_img: "/PostCarousel/Jerusalem/gardentomb.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Garden_Tomb",
  },
  {
    title: "YAD VASHEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/yadvashem.jpg",
    side_img: "/PostCarousel/Jerusalem/yadvashem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Yad_Vashem",
  },
  {
    title: "EIN KAREM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/einkarem.jpg",
    side_img: "/PostCarousel/Jerusalem/einkarem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Ein_Karem",
  },
  {
    title: "ELAH VALLEY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Jerusalem/elahvalley.jpg",
    side_img: "/PostCarousel/Jerusalem/elahvalley.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Elah_Valley",
  },
  {
    title: "Qasr Al-Yahud",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/qasralyahud.jpg",
    side_img: "/PostCarousel/valleydesert/qasralyahud.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Qasr_Al_Yahud",
  },
  {
    title: "Qumran",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/qumran.jpg",
    side_img: "/PostCarousel/valleydesert/qumran.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Qumran",
  },
  {
    title: "EIN GEDI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/eingedi.jpg",
    side_img: "/PostCarousel/valleydesert/eingedi.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "christian",
    id: "Ein_Gedi",
  },
  {
    title: "BREAKFAST IN ISRAEL",
    // "sml_desc" : "A LEGEND IN ITS OWN MEALTIME",
    sml_desc: "",
    // "desc" : "",
    desc: "",
    img: "/PostCarousel/Culinary/breackfast-in-israel.jpg",
    img_mob: "/PostCarousel/video_mob/breackfast-in-israel.jpg",
    side_img: "/PostCarousel/Culinary/breackfast-in-israel.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Breakfast-In-Israel",
    isVid: true,
    isDouble: false,
    vidId: "JJ7PhOw1p5E",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinary",
    id: "Breakfast-In-Israel",
  },
  {
    title: "Tel Aviv Vegan Scene",
    // "sml_desc": "Voted # 1 Vegan destination in the world  ",
    // "desc": "Enjoy the huge choice of vegan",
    sml_desc: "",
    desc: "",
    img: "Videos/h.jpg",
    img_mob: "/Videos/video_mob/h.jpg",
    side_img: "Videos/sidebar/h.jpg",
    vidId: "prLvetkAWwg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=6",
    ctg: "culinary",
    isVid: true,
    isDouble: false,
    id: "Vegan_Friendly_TelAviv",
  },
  {
    // "title": "A Foodie’s Paradise‘",
    title: "Simply Delicious",
    // "sml_desc": "Check out Tel Aviv’s \n awesome culinary Scene",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/99.jpg",
    img_mob: "/PostCarousel/video_mob/99.jpg",
    side_img: "/PostCarousel/99.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=21",
    ctg: "culinary",
    vidId: "n4kCnPXEX7g",
    isVid: true,
    isDouble: false,
    id: "Simply_Delicious",
  },
  {
    title: "Coffee in Tel Aviv",
    // "sml_desc": "Tel Aviv over a fresh coffee",
    sml_desc: "",
    // "desc": "Coffee shop culture is fundamental",
    desc: " ",
    img: "Videos/coffee.jpg",
    img_mob: "/Videos/video_mob/coffee.jpg",
    side_img: "Videos/sidebar/coffee.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=16",
    vidId: "rVr0gqFC364",
    ctg: "culinary",
    isVid: true,
    isDouble: false,
    id: "Coffee_In_TelAviv",
  },
  {
    title: "GOURMET TEL AVIV",
    // "sml_desc": "The perfect place\n to treat yourself",
    sml_desc: "",
    // "desc": "Tel Aviv's huge variety of amazing",
    desc: "",
    img: "Videos/gourmet-telaviv.jpg",
    img_mob: "/Videos/video_mob/gourmet-telaviv.jpg",
    side_img: "Videos/sidebar/gourmet-telaviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?postType=video&post=33",
    vidId: "jfyHxk8ZRrI",
    ctg: "culinary",
    isVid: true,
    isDouble: false,
    id: "Gourmet_TelAviv",
  },
  {
    title: "Jamie Oliver in Tel Aviv",
    // "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
    sml_desc: "",
    desc: "",
    img: "Videos/jamie-oliver.jpg",
    img_mob: "/Videos/video_mob/jamie-oliver.jpg",
    side_img: "Videos/sidebar/jamie-oliver.jpg",
    vidId: "gGe4W8WaIiQ",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Jamie_Oliver",
    ctg: "culinary",
    isVid: true,
    isDouble: false,
    id: "Jamie_Oliver",
  },
  {
    title: "A taste of Jerusalem",
    // "sml_desc": "Must eat dishes to try when visiting the magical city",
    desc: "",
    sml_desc: "",
    img: "/PostCarousel/37.jpg",
    img_mob: "/PostCarousel/video_mob/37.jpg",
    side_img: "/PostCarousel/37.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=38",
    ctg: "culinary",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    isDouble: false,
    id: "A_Taste_Of_Jerusalem",
  },
  {
    title: "Discover the Wine Routes",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/discover-the-wine-routes.jpg",
    img_mob: "/PostCarousel/video_mob/discover-the-wine-routes.jpg",
    side_img: "/PostCarousel/discover-the-wine-routes.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Discover_The_Wine_Routes",
    css_class: "unic-post-discover-the-wine-routes",
    isVid: true,
    isDouble: false,
    vidId: "Cxii1yKqKwI",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinary",
    id: "Discover_The_Wine_Routes",
  },
  {
    title: "Cheers to Israel",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/cheers-to-israel.jpg",
    img_mob: "/PostCarousel/video_mob/cheers-to-israel.jpg",
    side_img: "/PostCarousel/cheers-to-israel.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=Cheers_To_Israel",
    css_class: "unic-post-cheers-to-israel",
    isVid: true,
    isDouble: false,
    vidId: "Cxii1yKqKwI",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinary",
    id: "Cheers_To_Israel",
  },
  {
    title: "A Galilean treat",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilean-treat.jpg",
    img_mob: "/PostCarousel/video_mob/galilean-treat.jpg",
    side_img: "/PostCarousel/galilean-treat.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=A_Galilean_Treat",
    css_class: "unic-post-galilean-treat",
    isVid: true,
    isDouble: false,
    vidId: "kF808ENuuTQ",
    // "isVid": false,
    forVidPage: true,
    ctg: "culinary",
    id: "A_Galilean_Treat",
  },
  {
    title: "Pride Parade 2018",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/pride-parade-2018.jpg",
    img_mob: "/PostCarousel/video_mob/pride-parade-2018.jpg",
    side_img: "/PostCarousel/pride-parade-2018.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=pride-parade-2018",
    css_class: "unic-post-pride-parade-2018",
    isVid: true,
    isDouble: false,
    vidId: "U8KwXVP3Xng",
    // "isVid": false,
    forVidPage: true,
    ctg: "lgbtq",
    id: "pride-parade-2018",
  },
  {
    title: "TEL AVIV YA HABIBI TEL AVIV",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/tel-aviv-ya-habibi-tel-aviv.jpg",
    img_mob: "/PostCarousel/video_mob/tel-aviv-ya-habibi-tel-aviv.jpg",
    side_img: "/PostCarousel/tel-aviv-ya-habibi-tel-aviv.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=tel-aviv-ya-habibi-tel-aviv",
    css_class: "unic-post-tel-aviv-ya-habibi-tel-aviv",
    isVid: true,
    isDouble: false,
    vidId: "Bjf9neovBtM",
    forVidPage: true,
    ctg: "lgbtq",
    id: "tel-aviv-ya-habibi-tel-aviv",
  },
  {
    title: "PRIDE PARADE 2017",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/pride-parade-2017.jpg",
    img_mob: "/PostCarousel/video_mob/pride-parade-2017.jpg",
    side_img: "/PostCarousel/pride-parade-2017.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=pride-parade-2017",
    css_class: "unic-post-galilean-treat",
    isVid: true,
    isDouble: false,
    vidId: "PtyoZ9V4h74",
    forVidPage: true,
    ctg: "lgbtq",
    id: "pride-parade-2017",
  },
  {
    title: "Cycle tour in Western Galilee - Yechiam single and Cabri single",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/western-galilee-yechiam-cabri.jpg",
    img_mob: "/PostCarousel/video_mob/western-galilee-yechiam-cabri.jpg",
    side_img: "/PostCarousel/western-galilee-yechiam-cabri.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=western-galilee-yechiam-cabri",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    isDouble: false,
    vidId: "",
    forVidPage: false,
    ctg: "active-adventure",
    id: "western-galilee-yechiam-cabri",
  },
  {
    title: "ISRAEL NATIONAL TRAIL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/israel-national-trail.jpg",
    img_mob: "/PostCarousel/video_mob/israel-national-trail.jpg",
    side_img: "/PostCarousel/israel-national-trail.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=israel-national-trail",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    isDouble: false,
    vidId: "",
    forVidPage: false,
    ctg: "active-adventure",
    id: "israel-national-trail",
  },
  {
    title: "Israel National Trail Part 2- Tel Chai to Koach Fort",
    sml_desc: "",
    desc: "",
    img:
      "/PostCarousel/israel-national-trail-part-2-tel-chai-to-koach-fort.jpg",
    img_mob:
      "/PostCarousel/video_mob/israel-national-trail-part-2-tel-chai-to-koach-fort.jpg",
    side_img:
      "/PostCarousel/israel-national-trail-part-2-tel-chai-to-koach-fort.jpg",
    read_more: "READ MORE",
    link:
      "/Posts/index.php?post=israel-national-trail-part-2-tel-chai-to-koach-fort",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    isDouble: false,
    vidId: "",
    forVidPage: false,
    ctg: "active-adventure",
    id: "israel-national-trail-part-2-tel-chai-to-koach-fort",
  },
  {
    title: "Israel National Trail Part 3- Yesha (koach) Fort to Nachal Dishon",
    sml_desc: "",
    desc: "",
    img:
      "/PostCarousel/israel-national-trail-part-3-yesha-fort-to-nachal-dishon.jpg",
    img_mob:
      "/PostCarousel/video_mob/israel-national-trail-part-3-yesha-fort-to-nachal-dishon.jpg",
    side_img:
      "/PostCarousel/israel-national-trail-part-3-yesha-fort-to-nachal-dishon.jpg",
    read_more: "READ MORE",
    link:
      "/Posts/index.php?post=israel-national-trail-part-3-yesha-fort-to-nachal-dishon",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    isDouble: false,
    vidId: "",
    forVidPage: false,
    ctg: "active-adventure",
    id: "israel-national-trail-part-3-yesha-fort-to-nachal-dishon",
  },
  {
    title: "Israel National Trail Part 4- Nachal Dishon to Mount Meron",
    sml_desc: "",
    desc: "",
    img:
      "/PostCarousel/israel-national-trail-part-4-nachal-dishon-to-mount-meron.jpg",
    img_mob:
      "/PostCarousel/video_mob/israel-national-trail-part-4-nachal-dishon-to-mount-meron.jpg",
    side_img:
      "/PostCarousel/israel-national-trail-part-4-nachal-dishon-to-mount-meron.jpg",
    read_more: "READ MORE",
    link:
      "/Posts/index.php?post=israel-national-trail-part-4-nachal-dishon-to-mount-meron",
    css_class: "unic-post-galilean-treat",
    isVid: false,
    isDouble: false,
    vidId: "",
    forVidPage: false,
    ctg: "active-adventure",
    id: "israel-national-trail-part-4-nachal-dishon-to-mount-meron",
  },
];



// WEBPACK FOOTER //
// ./src/Data/Data.js